/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
import { Icon, Button } from 'semantic-ui-react'
import { Element } from 'react-scroll'
import { TopMenu } from '../menu'
import { SegmentHeader } from '../segmentheader'
import { SectionOverview } from '../sectionoverview'
import { VideoPlayer } from '../videoplayer'
import { SideElement } from '../sideelement'
import { CareerStats } from '../careerstats'

import menuData from '../../../data/menu.json'

const ARTICLE_ID = '879766169010'
const parseJsonData = json => {
  return json.data
}
const isMobile = window.innerWidth < 768

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false
    }
    this.menuRef = React.createRef()
    this.closeMenu = this.closeMenu.bind(this)
    this.openMenu = this.openMenu.bind(this)
  }

  openMenu() {
    this.setState({ menuOpen: true })
    this.menuRef.current.setMenuPosition()
    // Disable body scroll?? npm body-scroll-lock
  }

  closeMenu() {
    this.setState({ menuOpen: false })
    // Re-enable body scroll?? npm body-scroll-lock
  }

  componentDidMount() {
    // restore scroll position from previous visit?
    if (!window.location.hash) {
      if (localStorage.getItem('scrllPstn')) {
        const scrllPstn = parseFloat(localStorage.getItem('scrllPstn'))
        if (scrllPstn && scrllPstn > 650) {
          // console.log('restore:', scrllPstn)
          document.documentElement.scrollTop = isMobile
            ? scrllPstn
            : scrllPstn - scrllPstn / 6 // scrllPstn/6 is just a weird correction, don't know why this is necessary...
        }
      }
    }
    window.addEventListener(
      'scroll',
      function() {
        if (timer !== null) {
          clearTimeout(timer)
        }
        const timer = setTimeout(function() {
          const scrllPstn = document.documentElement.scrollTop
          localStorage.setItem('scrllPstn', scrllPstn.toString())
        }, 150)
      },
      false
    )
  }

  componentWillUnmount() {
    // console.log('componentWillUnmount')
    window.removeEventListener('scroll')
  }

  render() {
    return (
      <div className='index'>
        <Masthead
          articleId={ARTICLE_ID}
          mediaName='dasmagazin'
          fullMediaName='Das Magazin'
          homepage='https://www.dasmagazin.ch'
        />
        <ThemeSwitch />

        <header className='ui vertical  very fitted titleImage  segment'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Wer ich wirklich bin</h1>
              <h2>
                Die Geschichte von Martina Hingis, der besten Sportlerin, die
                die Schweiz je hatte.
              </h2>
            </div>
          </div>
        </header>
        <div className='content'>
          <div className='ui container'>
            <figcaption>Foto: Cyrill Matter</figcaption>
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>Christof Gertsch, Mikael Krogerus</div>
              <div className='ta updated'>Aktualisiert am 29. Oktober 2021</div>
            </div>
          </div>
        </div>

        <div className='content' onClick={isMobile ? this.closeMenu : null}>
          <Element className='section' name='section-1' id='section-1'>
            <div className='ui vertical segment' style={{ padding: '0' }}>
              <div className='ui text container'>
                <div className='ta text prologue'>
                  <h5>Prolog</h5>
                  <p>
                    Im Juni 2020, wenige Tage nach dem Ende des Corona-Lockdown,
                    sassen wir in der Lobby des Grand Resort Bad Ragaz, und die
                    grösste Sportlerin, die die Schweiz je hatte, die lange so
                    gut wie nichts mit den Medien zu tun haben wollte, schaute
                    uns fragend an.
                  </p>
                  <p>
                    Es war nicht ganz einfach gewesen, mit Martina Hingis ins
                    Gespräch zu kommen. Nach vielen Absagen über Jahre hinweg
                    hatte sie schliesslich doch eingewilligt, mit uns zu reden.
                    Aus einem Gespräch waren viele geworden, in denen sie uns
                    nach und nach ihr Leben erzählte. Fast ein Jahr lang hatten
                    wir uns immer wieder getroffen, als plötzlich die Rückfrage
                    kam:
                  </p>
                  <p>
                    «Wieso macht ihr das eigentlich, wieso wollt ihr so viel
                    Zeit mit mir verbringen?»
                  </p>
                  <p>«Wieso machen Sie mit?», fragten wir zurück.</p>
                  <p>
                    «Weil ich gemerkt habe, dass ich hier vielleicht einmal
                    meine Sicht darstellen kann. Mich so zeigen kann, wie ich
                    wirklich bin. Ich denke, die Chance ist da. Ich hoffe, es
                    kommt auch so.»
                  </p>
                  <p>
                    Sie, die sonst ohne Punkt und Komma sprach, ständig scherzte
                    und lachte, machte nun eine längere Pause.
                  </p>
                  <p>
                    «Ich möchte einfach, dass endlich mein wahres Ich gezeigt
                    wird. Nicht die arrogante Zicke, die wieder mal kein
                    Interview gegeben hat, sondern die Martina, die ich bin.»
                  </p>
                  <p>
                    Und dann folgte, was sie uns ab da immer wieder sagte, bis
                    zum letzten Treffen kurz vor Erscheinen dieses Texts: «Meine
                    Geschichte ist keine Opfergeschichte, sie ist eine
                    Erfolgsgeschichte.» 
                  </p>
                </div>
              </div>
            </div>
          </Element>

          <div className='ui text container'>
            <SectionOverview
              menuData={parseJsonData(menuData)}
              closeMenu={this.closeMenu}
            />
          </div>
        </div>

        <div className='sticky-wrapper'>
          <div className='menu-toggle'>
            <div className='button-wrapper'>
              <Button onClick={this.openMenu}>
                <Icon name='bars' />
              </Button>
            </div>
          </div>

          <div className='content' onClick={isMobile ? this.closeMenu : null}>
            <Element className='section' name='section-2' id='section-2'>
              <div className='ui vertical segment'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h5>
                      Warum es zu dieser {isMobile && <br />}Geschichte kam
                    </h5>
                    <p>
                      Die Tennisspielerin Martina Hingis ist einer jener
                      Menschen, von denen man denkt, dass man eigentlich alles
                      über sie weiss. Selbst wer Tennis nicht von Squash
                      unterscheiden kann, hat mitbekommen, dass sich in den
                      1990er-Jahren ein Teenager aus der Schweiz an die
                      Weltspitze spielte und zur jüngsten Nummer 1 der
                      Geschichte wurde. Ein technisch und taktisch
                      aussergewöhnliches, vielleicht nie zuvor dagewesenes
                      Tennistalent, das auf die Topspin-Maschinerie von Steffi
                      Graf und Monica Seles mit Spielfreude und Raffinesse
                      antwortete.
                    </p>
                    <p>
                      Bekannt ist zudem, dass sie etliche Grand-Slam-Titel
                      gewann und jahrelang die Weltrangliste anführte. In
                      Erinnerung blieb auch, dass es eine Kokainaffäre gab. Dass
                      sich Hingis vom Tennis verabschiedete und wieder
                      zurückkam. Dass sie nicht auf den Mund gefallen war. Dass
                      sie eine strenge Mutter hatte, die sie trainierte und über
                      sie wachte und die 1997 sagte: «Bei Patty (Schnyder) ist
                      immer alles positiv, bei uns nicht. Martina ist immer die
                      Ausländerin.»
                    </p>
                    <p>Wenn man so will, ist damit alles gesagt.</p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/2-0-wimbledon-1996.jpg'
                          : '../../images/2-0-wimbledon-1996-desktop.jpg')}
                      />
                      <figcaption>
                        Gefeiert überall auf der Welt – aber nie so richtig in
                        der Schweiz: Martina Hingis 1996 in Wimbledon. Foto:
                        Laci Perenyi (Imago)
                      </figcaption>
                    </SideElement>
                    <p>
                      Trotzdem hatten wir das Gefühl: Eigentlich ist überhaupt
                      nichts gesagt. Von Roger Federer gibt es – schnell gezählt
                      – zwölf Biografien, von Martina Hingis keine einzige.
                      Nicht mal ein ausführliches Porträt. Nach ihrem Rücktritt
                      2017 erschienen sporadisch oft nichtssagende Interviews.
                      Und irgendwann gar keine mehr. Sie hatte sich
                      zurückgezogen, enttäuscht nicht von der Schweiz, aber von
                      den immergleichen negativen Medienberichten über sie.
                    </p>
                    <p>
                      Über zwei Jahre haben wir uns Martina Hingis angenähert,
                      haben recherchiert, gelesen und uns mit Weggefährtinnen
                      und Gegnerinnen von Florida bis Taiwan unterhalten. Vor
                      allem haben wir mit ihr selbst und schliesslich auch mit
                      ihrer Mutter, Melanie Molitor, gesprochen, in Tennishallen
                      und Restaurants, auf Spaziergängen, bei Hingis zu Hause
                      und in ihrem Stall, wo sie uns ihre Pferde zeigte.
                    </p>
                    <p>
                      Eines der einzigen Bücher über Hingis, und zwar ein sehr
                      gutes, stammt vom Westschweizer Schriftsteller Étienne
                      Barilier, der sonst über Bach und Giacometti schrieb. Auch
                      das Spiel der jungen Hingis betrachtete er literarisch,
                      mit dem Auge des Bewunderers.
                    </p>
                    <p>
                      Bariliers Buch ist vergriffen, aber das Exemplar, das wir
                      auftreiben konnten, war uns Hilfe und Inspiration.
                      Barilier hatte seine Arbeit Ende 1996 fertiggestellt, also
                      vor dem grossen Durchbruch von Hingis, was die Lektüre ein
                      Vierteljahrhundert später nur noch eindrücklicher macht.
                    </p>
                    <p>
                      Unsere Geschichte beginnt auf einem Tennisplatz in Rožnov
                      in der damaligen Tschechoslowakischen Sozialistischen
                      Republik (ČSSR), wo Martina Hingis im Alter von drei
                      Jahren das erste Mal einen Tennisschläger in die Hand
                      nahm. Sie war ein Wunderkind, wurde eine Legende ihres
                      Sports, gefeiert überall auf der Welt – nur nicht so
                      richtig hier in der Schweiz.
                    </p>
                    <p>
                      Das Land scheint Martina Hingis – anders als Roger Federer
                      – nie so recht in sein Herz geschlossen zu haben. Es ist
                      schwierig, dieses diffuse Gefühl zu benennen, aber es
                      zeigte sich immer wieder: Obwohl ein internationaler
                      Superstar, hatte Hingis nie grosse Schweizer Sponsoren,
                      die NZZ nannte sie noch bei ihrem Rücktritt «die
                      Unvollendete», der Psychologe Allan Guggenbühl
                      ferndiagnostizierte eine «ungesunde» Beziehung zwischen
                      Mutter und Tochter, die «Schweizer Familie» stellte
                      Prominenten die Frage: «Verdient Martina Hingis zu viel?»,
                      und eine der renommiertesten Journalistinnen des Landes,
                      Margrit Sprecher, raunte genüsslich, die Mutter hätte den
                      biologischen Vater nach den richtigen Genen und den
                      Stiefvater nach den richtigen Papieren ausgewählt.
                    </p>
                    <p>
                      Als das Magazin «Facts» 1997 in einer repräsentativen
                      Untersuchung die «grösste Schweizer Sportlerin aller
                      Zeiten» ermittelte, setzte ein Drittel der Befragten
                      Hingis auf Platz 1. Doch in der Beliebtheitsrangliste sah
                      es anders aus. Da siegte die Läuferin Franziska
                      Rochat-Moser vor dem Skifahrer Michael von Grünigen und
                      der Läuferin Anita Weyermann. Martina Hingis folgte auf
                      Platz 12.
                    </p>
                    <p>
                      Im gleichen Jahr grub «10 vor 10» einen Bauernlehrling
                      aus, der in der Schule mal Sitznachbar von Hingis gewesen
                      war. Die erste Frage an ihn: «Wie viel verdienst du?»
                      (Antwort: «1300 Franken brutto.») Die «Story» des
                      Journalisten: Martina vs. Martin, sie reich, er arm, sie
                      abgehoben, er bodenständig. Und nach einem Turniersieg in
                      Tokio fragte der «Tagesschau»-Reporter sie am Flughafen:
                      «Verliert man nicht langsam den Boden unter den Füssen?»
                      Und: «Was macht man mit dem vielen Geld?»
                    </p>
                    <p>
                      Martina Hingis entsprach offensichtlich nicht dem Bild,
                      wie Frauen und besonders Einwanderinnen in der Schweiz
                      sein sollten: Sie war zu aufmüpfig, zu selbstbewusst. Und
                      zu erfolgreich.
                    </p>
                    <p>
                      «Ich habe dieses Bild von mir nie verstanden», sagt sie
                      uns einmal. «Ich hatte nie ein Problem mit der Schweiz.
                      Und ich glaube auch nicht, dass die Schweizer mit mir
                      eines hatten. Im Gegenteil. Wenn mir heute Menschen im Bus
                      sagen: ‹Wir sind aufgestanden mitten in der Nacht wegen
                      Ihnen, haben Ihnen zugeschaut und uns mit Ihnen gefreut› –
                      dann denke ich: Ich bin hier zu Hause, hier bin ich
                      glücklich.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/2-1-letterman_1997.jpg'
                          : '../../images/2-1-letterman_1997.jpg')}
                      />
                      <figcaption>
                        Am wichtigsten Tisch der USA: Martina Hingis im November
                        1997 zu Gast in der Late-Night-Show von David Letterman.
                        Foto: Keystone/AP Photo/CBS
                      </figcaption>
                    </SideElement>
                    <p>
                      Es ist heute schwer vorstellbar, aber als Hingis 1994 auf
                      der Profitour debütierte, gab es keine einzige Schweizerin
                      (und eigentlich auch keinen einzigen Schweizer), die auf
                      der ganzen Welt bekannt war. Zu einer Zeit, als die
                      Schweiz sehr auf sich fokussiert war – das EWR-Nein und
                      die Entwicklung der SVP zur wählerstärksten Partei prägten
                      die 1990er –, als die einzige im Ausland bekannte
                      Schweizerin die Kinderbuchfigur Heidi war, als Pirmin
                      Zurbriggen, Vreni Schneider und Stéphane Chapuisat mehr
                      regionale Berühmtheiten als globale Stars waren, in diese
                      Zeit fiel der Aufstieg von Martina Hingis.
                    </p>
                    <p>
                      Sie selbst stiess mit ihrem internationalen Erfolg auf
                      Widerstand, für andere war sie eine Wegbereiterin. Für
                      einen ganz besonders: Roger Federer. Die Schweiz ergötzte
                      sich für die überwiegende Dauer seiner Karriere an der
                      Tatsache, einen dermassen guten Tennisspieler in ihren
                      Reihen zu haben. Egal wie reich er dabei wurde, wie wenig
                      er überhaupt noch in der Schweiz auftrat, unabhängig
                      davon, dass er eine südafrikanische Mutter hat.
                    </p>
                    <p>
                      Wir fragten ihn, ob er das auch so sehe. Er schrieb uns:
                      «Martina war tatsächlich sehr wichtig für mich, weil vor
                      ihr noch nie jemand aus der Schweiz einen Weltsport derart
                      dominiert hatte. Sie war eine Inspiration und ein
                      unglaubliches Vorbild. Sie motivierte mich und zeigte, was
                      möglich ist. Es ist absolut unglaublich, was sie in so
                      einem jungen Alter alles erreichte.»
                    </p>
                    <p>
                      Die erste Schweizerin, die man nicht nur in ganz Europa,
                      sondern auch in Asien, Südamerika, Australien und den USA
                      kannte, die beim legendären Talkmaster David Letterman
                      ebenso lässig auftrat wie in japanischen Spielshows, die
                      Millionen verdiente und um die Welt jettete – kurz: Der
                      erste Schweizer Superstar war eine Teenagerin, eine Frau,
                      eine Migrantin.
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/01-japan-gameshow.mp4')}
                        posterImage={require('../../videos/01-japan-gameshow.jpg')}
                        caption='Alle gegen eine: Japanische TV-Show 2012. Material: <a href="https://www.youtube.com/watch?v=0KlKBSOGwWE&t=230s">Taiku-Kay TV/Youtube</a>'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Element>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-3' id='section-3'>
                <SegmentHeader
                  part='Erster Teil'
                  title='Kindheit in der ČSSR'
                  image={require(isMobile
                    ? '../../images/3-privat.jpg'
                    : '../../images/3-privat-desktop.jpg')}
                  caption='Foto: Privat'
                />
              </Element>

              <Element className='section' name='section-3-1' id='section-3-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 1</h6>
                    <h5>Als die Mutter von der Freiheit träumte</h5>
                    <p>
                      Melanie Molitor kam 1957 in Rožnov zur Welt, einer
                      Kleinstadt im Gebiet Mähren im tschechischen Teil der
                      damaligen Tschechoslowakischen Republik (ČSR). Ihre Mutter
                      war Schulleiterin, ihr Vater Landschaftsarchitekt. Er
                      stammte aus der rumänischen Walachei und war für Melanie
                      Molitor eine prägende Figur: Im Zweiten Weltkrieg hatte er
                      sich gegen die deutsche Besatzungsmacht aufgelehnt, dann
                      widersetzte er sich dem kommunistischen Regime und wurde
                      zu acht Jahren Arbeitslager in einer Uranmine verurteilt.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-1-privat.jpg'
                          : '../../images/3-1-privat.jpg')}
                      />
                      <figcaption>
                        Der Dissident und seine Nachkommen: Martina Hingis im
                        Schoss ihres Grossvaters. Foto: Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      «Die Kommunisten wollten ihn brechen», sagt Melanie
                      Molitor. «Das gelang ihnen nicht, aber sie schadeten ihm
                      und unserer Familie.» Sie bewunderte ihren Vater für sein
                      Rückgrat und seinen Mut und war ihm dankbar für seinen
                      Glauben an sie.
                    </p>
                    <p>
                      Schon als Kind ahnte sie, dass sie als Tochter eines
                      Dissidenten Schwierigkeiten haben würde. Später verstand
                      sie, dass sie weggehen musste, wenn sie frei sein wollte.
                      Ihre Chance sah sie im Sport. Nur dort, dachte sie, würde
                      niemand fragen, welche politischen Ansichten ihr Vater
                      vertrat.
                    </p>
                    <p>
                      «Für Schweizer Verhältnisse sind das natürlich Hügel, was
                      wir in Rožnov hatten», sagt sie uns. «Aber für mich waren
                      es Berge. Ich wurde Sportlerin, um über die Berge zu
                      kommen.» Die Berge waren für Molitor eine Metapher für den
                      Eisernen Vorhang.
                    </p>
                    <p>
                      Zum Tennis fand sie durch ihren älteren Bruder. Ihrer
                      Mutter war es wichtig, was sie in der Schule leistete,
                      weshalb sie nur ins Training durfte, wenn sie gute Noten
                      hatte. Weil es keine Hallen gab, trainierte sie im Winter
                      Langlauf und schaffte es fast ins Nationalteam. Doch
                      Tennis gefiel ihr besser.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-2-melanie-molitor.jpg'
                          : '../../images/3-2-melanie-molitor.jpg')}
                      />
                      <figcaption>
                        Mit zehn gewann Martina Hingis zum ersten Mal gegen ihre
                        Mutter. Foto: Art Seitz (Gamma-Rapho/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Mit zwanzig ging Molitor nach Košice, einer Stadt im
                      slowakischen Teil der damaligen ČSSR, und nahm das Angebot
                      an, für den dortigen Tennisklub bei den
                      Vereinsmeisterschaften anzutreten. Der Entscheid stellte
                      sich als Fehler heraus, aber nur aus sportlicher Sicht.
                      Sie war unzufrieden mit den Trainingsmöglichkeiten und
                      überfordert vom Niveau in der obersten Liga, doch sie
                      lernte Karol Hingis kennen, einen Stammspieler des
                      Tennisklubs VSŽ Košice, und gebar am 30. September 1980,
                      drei Jahre nach ihrer Ankunft in Košice, eine Tochter.
                    </p>
                    <p>
                      Sie nannte ihre Tochter nach der damals besten
                      Tennisspielerin der Welt, Martina Navrátilová. Aber nicht
                      wegen ihrer sportlichen Ausnahmeleistungen, wie es später
                      oft hiess, sondern weil Navrátilová fünf Jahre zuvor die
                      ČSSR hinter sich gelassen und in den USA politisches Asyl
                      beantragt hatte. Für Melanie Molitor war der Name Martina
                      ein Symbol der Hoffnung und der Freiheit.
                    </p>
                    <p>
                      Drei Jahre blieb die junge Mutter in Košice, dann zog sie
                      mit ihrer Tochter zurück nach Rožnov. Sie hatte in einer
                      Fabrik gearbeitet und Kindergärtnerin gelernt, nun
                      übernahm sie ein Café, das zehn Minuten zu Fuss von ihrer
                      Wohnung entfernt lag und zu einer Tennisanlage gehörte.
                    </p>
                  </div>
                </div>
              </Element>
              <Element className='section' name='section-3-2' id='section-3-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 2</h6>
                    <h5>Wie der Kommunismus das Tennis entdeckte</h5>
                    <p>
                      1948 formulierte das Zentralkomitee der Kommunistischen
                      Partei der Sowjetunion (KPdSU) den Plan, «die
                      kapitalistischen Länder auf dem Gebiet der Sportrekorde
                      einzuholen und zu überholen». Man durchsuchte die
                      kommunistischen Länder nach talentierten Jugendlichen, um
                      sie in straff geführten Sportinternaten teilweise bis zur
                      Erschöpfung zu trainieren. Unterstützt wurde der Drill
                      durch hochmoderne Sportwissenschaft und – wie man heute
                      weiss – systematisches Doping.
                    </p>
                    <p>
                      Die Massnahmen zeigten schnell Wirkung: Bei den
                      Olympischen Sommerspielen 1952 in Helsinki belegte die
                      Sowjetunion in der Medaillenwertung Rang 2. Vier Jahre
                      später war sie bereits Erste, sowohl an den Winter- als
                      auch den Sommerspielen.
                    </p>
                    <p>
                      Jedes kommunistische Land entwickelte seine
                      Spezialdisziplinen: Ungarn war im Fechten, Ringen und
                      Schwimmen spitze, Rumänien im Turnen. In der ČSR
                      konzentrierte man sich auf Eishockey, Fussball und Turnen.
                      Tennis galt als «Freizeitvergnügen des Klassenfeindes».
                      Als Jaroslav Drobný 1954 Wimbledon gewann, erschien
                      darüber in der tschechoslowakischen Presse kein Wort – er
                      war 1949 aus der ČSR emigriert.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-3-martina-navratilova.jpg'
                          : '../../images/3-3-martina-navratilova.jpg')}
                      />
                      <figcaption>
                        Martina Navrátilová: Serve-and-Volley-Ikone,
                        Freiheitssucherin, Namensgeberin von Martina Hingis.
                        Foto: Leo Mason (Popperfoto/Getty Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Das änderte sich, als Věra Suková 1962 in den
                      Wimbledon-Final vorstiess und Jan Kodeš 1973 das Turnier
                      sogar gewann. Allmählich erkannte die Partei die
                      Signalwirkung der Tennisspielerinnen und Tennisspieler,
                      die im Westen erfolgreich waren. Mit dem Slogan «Wer ist
                      die neue Suková, wer der neue Kodeš?» versuchte man 1975 –
                      im Jahr, als Martina Navrátilová in die USA floh – neue
                      Talente aufzuspüren.
                    </p>
                    <p>
                      Zwei Ausnahmeerscheinungen wurden auf diesem Weg entdeckt:
                      Hana Mandlíková und Ivan Lendl. Beide nahmen später
                      ebenfalls andere Staatsbürgerschaften an, doch ihre
                      Erfolge feierten sie für die ČSSR. Das beendete die
                      Skepsis der Parteiführung gegenüber dem
                      «Kapitalistensport». Tennis wurde zu einem Schwerpunkt des
                      tschechoslowakischen Sports.
                    </p>
                  </div>
                </div>
              </Element>
              <Element className='section' name='section-3-3' id='section-3-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 3</h6>
                    <h5>Martina Hingis will spielen, nicht trainieren</h5>
                    <p>
                      Als Melanie Molitor 1983 nach Rožnov zurückkehrte, war sie
                      zwar zu einer grossartigen Sportlerin geworden, aber
                      besonders weit über die Berge gekommen war sie nicht. Aus
                      dem Land heraus schon gar nicht.
                    </p>
                    <p>
                      Ihr Traum, dass der Sport ihr die Freiheit schenken würde,
                      wandelte sich zum Plan, ihrer Tochter diese Möglichkeit zu
                      verschaffen. Martina Hingis sollte so gut werden, dass sie
                      die Enge der ČSSR verlassen könnte.
                    </p>
                    <p>
                      Später in der Schweiz war das häufig ein Anlass für
                      Missverständnisse. Viele sahen in Molitor eine gnadenlose
                      Tennis-Mami, eine Art weibliche Nick Bollettieri, die ihre
                      Tochter zu dem Erfolg zwang, den sie selbst nicht erreicht
                      hatte, die Martina ihrer Kindheit beraubte und mit ihr
                      Geld verdienen wollte. Doch um Ruhm oder Geld ging es ihr
                      nie.
                    </p>
                    <p>
                      «Wenn ich heute sage, ein Traum sei in Erfüllung gegangen,
                      meine ich nicht Martinas Erfolge», sagt sie uns. «Ich
                      meine, dass ihre Erfolge es uns möglich machten, die Welt
                      zu sehen.»
                    </p>
                    <p>
                      Und tatsächlich: Als Martina Hingis 1993 mit zwölf Jahren
                      am French Open in Paris das Juniorinnenturnier gewann –
                      als bis heute jüngste Spielerin der Geschichte –, bestand
                      die Mutter darauf, dass die beiden nach dem Training und
                      zwischen den Spielen die Notre-Dame, den Eiffelturm, die
                      Sacré-Cœur besuchten.
                    </p>
                    <p>
                      «Sie wollte, dass wir rauskommen, etwas anderes sehen,
                      nicht immer nur Tennis, Tennis, Tennis», erinnert sich
                      Martina Hingis. «Mich hat das ziemlich genervt, aber heute
                      denke ich: Bei anderen Tenniskindern geht viel verloren in
                      der Juniorenzeit. Meine Mutter wollte mir neben dem Tennis
                      auch die Welt zeigen.»
                    </p>
                    <p>
                      Der Weg dahin – das verstand Melanie Molitor früh – musste
                      ein anderer als ihr eigener sein. Schon während ihrer
                      Karriere hatte sie analysiert, warum es für sie nicht
                      reichte im Vergleich zu Lendl, Mandlíková, Navrátilová:
                      Die hatten das ganze Jahr über Tennis gespielt, jeden Tag
                      fünf oder sechs Stunden, während sie im Winter langlaufen
                      gegangen war. Ihr fehlten, so schloss sie, jedes Jahr
                      mehrere Monate Training. Sie hatte zahllose Bälle weniger
                      geschlagen als die anderen, und das hatte den Unterschied
                      gemacht.
                    </p>
                    <p>
                      Im Alter von drei Jahren konnte Martina den Ball mit ihrer
                      Mutter bereits fünfzehn Mal hin- und herspielen. Als sie
                      vier war, erhöhte die Mutter des Trainingspensum auf
                      zwanzig Minuten am Tag. Mit fünf stand Martina täglich
                      vier bis fünf Stunden auf dem Platz.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-4-privat.jpg'
                          : '../../images/3-4-privat.jpg')}
                      />
                      <figcaption>
                        Millionen Eltern haben ein solches Foto von ihrem Kind.
                        Aber nur auf diesem hier ist Martina Hingis. Foto:
                        Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      Das sind ihre ersten Erinnerungen an den Tennisplatz: «Wir
                      gingen immer mit dem Velo hin und verbrachten den ganzen
                      Tag dort, jeden Tag, ob Ferien oder nicht, bis ich mit
                      sieben in die Schule kam. Vierzig, fünfzig Kinder waren
                      da, und auf fünf Sandplätzen fünf verrückte Eltern, die
                      uns trainierten, darunter meine Mutter. Die Anlage befand
                      sich in einem Park. Waren die Plätze voll, spielten wir
                      etwas anderes: Verstecken, Fangen, Räuber und Polizei. Ich
                      liebte es.»
                    </p>
                    <p>
                      Vielleicht ist an dieser Stelle noch einmal ein kurzer
                      Rückblick in die Wirklichkeit des Kommunismus notwendig,
                      um zu verstehen, was damals in Rožnov geschah: In der ČSSR
                      waren praktisch alle berufstätig, auch die Frauen, aber
                      der Beruf hatte nicht die gleiche Bedeutung wie im Westen.
                      Arbeit war für die meisten nichts, mit dem sie brillieren
                      konnten, denn ausserhalb der Partei gab es kaum
                      Aufstiegsmöglichkeiten, kaum Karriereaussichten. Leistung
                      im Beruf lohnte sich nicht.
                    </p>
                    <p>
                      Wer den Drang verspürte, etwas im Leben zu erreichen,
                      verlegte seine Aufmerksamkeit häufig auf andere Dinge. Auf
                      den Sport zum Beispiel. In der Schweiz ist es umgekehrt:
                      Wer hier von Erfolg spricht, meint in der Regel
                      beruflichen Erfolg. Wer hier Tennis spielt, macht das als
                      Ausgleich zum Beruf, weil es gesund ist oder Spass macht.
                      Und wer in der Jugend Sport macht, vielleicht sogar
                      Spitzensport, erhofft sich davon nicht unbedingt ein
                      besseres Leben, sondern leitet umgekehrt später
                      Fähigkeiten wie Durchhaltewillen, Teamgeist oder Disziplin
                      daraus ab, die auch im <i>Beruf</i> wichtig sind.
                    </p>
                    <p>
                      Für die Eltern, die sich auf der Tennisanlage in Rožnov
                      verabredeten, war der Einsatz ein kleines Aufbegehren
                      gegen das System. Und manche verbanden damit die Hoffnung,
                      das System vielleicht sogar verlassen zu können. So wie
                      Melanie Molitor.
                    </p>
                    <p>
                      Im Leben aller Eltern kommt wohl der Moment, in dem man
                      sich fragt, was für einen Charakter das eigene Kind hat.
                      Beim Spielen erhält man erste Hinweise. Manche Kinder
                      mögen Wettkämpfe: «Wer ist zuerst beim Baum?» Andere – wie
                      Martina Hingis – haben daran weniger Interesse.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/3-5-privat.jpg'
                          : '../../images/3-5-privat.jpg')}
                      />
                      <figcaption>
                        Vierzig Kinder und fünf tennisverrückte Eltern: Auf dem
                        Sandplatz in Rožnov. Foto: Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      Auf dem Platz war sie keine verbissene Arbeiterin, erzählt
                      uns ihre Mutter, sondern ein verspieltes Kind. Sie mochte
                      Ausdauertraining nicht, wollte den Bällen nicht
                      hinterherlaufen, langweilte sich bei monotonen Übungen.
                      Martina Hingis hatte keine Lust auf Training. Von allen
                      Kindern auf dem Tennisplatz in Rožnov war sie das jüngste
                      und kleinste. Aber auch das beste. Um ein Gefühl dafür zu
                      bekommen, <i>wie</i> gut Martina Hingis bereits als
                      Sechsjährige war, hilft es, sich sein sechsjähriges Kind
                      oder Enkelkind neben einem neunjährigen vorzustellen.
                      Selbst wenn es richtig, richtig gut ist, ist das
                      sechsjährige chancenlos. Egal in welchem Bereich. Weil es
                      schwächer ist und langsamer. Auch im Kopf.
                    </p>
                    <p>
                      Das war auch die sechsjährige Martina Hingis. Doch sie
                      kompensierte ihre Unterlegenheit mit etwas, das nur schwer
                      zu fassen ist. Ihre Mutter erklärt es uns folgendermassen,
                      in einem langen, immer intensiver werdenden Monolog an
                      ihrem Esstisch in Schindellegi oberhalb des Zürichsees:
                    </p>
                    <p>
                      «Martinas Vater kam aus dem Ungarisch-Slawischen. Die
                      slawischen Tennisspieler haben einen wahnsinnigen Schwung
                      und viel Ballgefühl. Die Ungarn wiederum sind
                      Schlitzohren. Meine Familie hingegen stammt von Hirten ab,
                      die einst vom Balkan über die Karpaten in die Walachei
                      gekommen waren. Wir sind ein sehr zähes Volk. Unsere
                      grösste Stärke ist die Anpassungsfähigkeit. Die Tschechen
                      sind immer gefallen. Gegen die Russen, die Polen, die
                      Deutschen. Dreihundert Jahre unter Herrschaft der
                      Habsburger, dann eine kurze Periode der Freiheit, dann
                      kamen die Nationalsozialisten, dann die Kommunisten. Ich
                      staune immer, dass die tschechische Sprache überlebt hat.
                      Das ist diese Anpassungsfähigkeit: Man wird überrollt,
                      aber lebt weiter, bleibt sich selbst. Wir wissen, was es
                      heisst, mit wenig auszukommen. Wenn wir uns gut
                      vorbereiten, schaffen wir es. Ich denke manchmal, dass wir
                      den Schweizern ziemlich ähnlich sind, die in den Bergen
                      überleben mussten. Ich bewundere diese Leute, die es sich
                      in so kargen Landschaften einrichteten und dort
                      überlebten. Und wenn man all das nun zusammennimmt, also
                      das schwungvolle slawische Tennis, die ungarische
                      Schlitzohrigkeit und die walachische Überlebenskunst,
                      dieses akribische Vorbereiten auf jede Situation, damit du
                      nie überrascht wirst, nicht von einem kalten Winter, aber
                      auch nicht von einem unerwarteten Schlag – ja, dann ist es
                      in der Summe das, was Martinas Spiel schon früh
                      ausgezeichnet hat.»
                    </p>
                    <p>
                      An dieser Stelle setzt sie ab und mustert uns.
                      Vergewissert sie sich, ob wir ihren ethnologischen
                      Ausführungen folgen? Dann fährt Melanie Molitor fort: «Ich
                      bin wirklich überzeugt: Vorher und nachher hat nie jemand
                      so Tennis gespielt wie Martina. Sie war nicht die
                      Stärkste, sie hat nicht am meisten Grand-Slam-Turniere
                      gewonnen, sie war nicht am längsten die Nummer 1. Aber sie
                      konnte Tennis <i>spielen</i>. Und das war für mich
                      wahnsinnig schön und auch wichtig. Zu sehen, dass sie
                      Tennis wirklich <i>spielt</i>. Ich werde häufig gefragt,
                      welcher Erfolg mir am meisten bedeutet. Ich sage dann
                      immer: Ihr erstes Kinderturnier, als ich zum ersten Mal
                      sah, dass sie Tennis wirklich <i>spielt</i>. Das war
                      genauso wichtig wie ein grosses Turnier zu gewinnen. Wenn
                      sie einen Grand-Slam-Titel gewann, aber nicht wirklich{' '}
                      <i>gespielt</i> hatte, dann gefiel mir das nicht.»
                    </p>
                    <p>
                      Und Martina spielte nicht nur mit grosser Freude, sondern
                      auch <i>viel</i>. Mit sechs Jahren blickte sie bereits auf
                      die Erfahrung von achtzig Turniermatches zurück, sie war
                      die beste tschechoslowakische Tennisspielerin bei den
                      unter Neunjährigen.
                    </p>
                    <p>
                      Das war 1986, zwei Jahre vor dem Umzug in die Schweiz. Das
                      Vertrauen in die eigenen Fähigkeiten, das sie sich in
                      Rožnov aneignete, aber auch ihre kindliche Freude auf dem
                      Platz sollten in ihrer neuen Heimat verblüffend häufig
                      missverstanden werden. Und ihr Leben bis heute prägen.
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-4' id='section-4'>
                <SegmentHeader
                  part='Zweiter Teil'
                  title='Das Wunderkind in der Schweiz'
                  image={require(isMobile
                    ? '../../images/4-paris.jpg'
                    : '../../images/4-paris-desktop.jpg')}
                  caption='Foto: Popperfoto/Getty Images'
                />
              </Element>

              <Element className='section' name='section-4-1' id='section-4-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 4</h6>
                    <h5>Zu gut für dieses Land</h5>
                    <p>
                      Am 4. September 1988 – an das Datum erinnern die zwei sich
                      wie an ihre Geburtstage – überquerten Melanie Molitor und
                      ihre acht Jahre alte Tochter die Grenze zur Schweiz. Für
                      die Mutter war es die lang ersehnte Reise über die Berge
                      in die Freiheit. Martina Hingis verband mit der Autofahrt
                      ganz andere Gefühle: «Alles, was mir wichtig war, musste
                      ich in Rožnov zurücklassen», sagt sie.
                    </p>
                    <p>
                      Sie waren unterwegs nach Grabs, Kanton St. Gallen, wo der
                      Computervertreter Andreas Zogg wohnte, Molitors neuer
                      Ehemann. Die beiden hatten sich auf einer seiner
                      Geschäftsreisen kennen gelernt. Er war ehrenamtlich in
                      einem Skiclub tätig und sprach über Skifahren so, wie sie
                      über Tennis. Das passt, dachte sie.
                    </p>
                    <p>
                      «Wenn ich gewusst hätte, dass 1989 der Eiserne Vorhang
                      fällt, wären wir nicht geflohen», sagt Melanie Molitor.
                      «Aber nun waren wir da. Und weil ich erkannte, dass der
                      Schweizer Sport – abgesehen vom Skifahren – im Mittelalter
                      feststeckte, fing ich an zu kämpfen.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-1-privat.jpg'
                          : '../../images/4-1-privat.jpg')}
                      />
                      <figcaption>
                        Sie spielte als Kind gegen Jugendliche: Im Juli 1990 in
                        der Schweiz. Foto: Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      Zwar gab es mehr als genug Tennisanlagen, doch die
                      Hobbyspieler:innen wollten die Platzzeiten nicht für ein
                      achtjähriges Mädchen freigeben.
                    </p>
                    <p>
                      Molitor: «Sagen wir es so, ich habe mich dann
                      organisiert.»
                    </p>
                    <p>
                      Auch ihre Tochter organisierte sich. «Die ersten Nächte
                      habe ich durchgeheult», sagt sie uns. «In Rožnov hatte ich
                      Cousinen, Freundinnen, wir waren den ganzen Tag gemeinsam
                      auf dem Tennisplatz. In Grabs war ich alleine. Ich
                      fürchtete mich vor dem ersten Schultag. Ich konnte ja kein
                      Wort Deutsch. Es war keine schöne Zeit. Aber sie hatte
                      etwas Gutes: Sie schweisste Mama und mich zusammen.»
                    </p>
                    <p>
                      Die Schulleitung wollte sie zuerst zurückstufen, doch die
                      Mutter beharrte darauf, dass man ihr eine Chance gibt, und
                      so stieg Martina Hingis nach den Herbstferien in der
                      zweiten Klasse ein. Sie reagierte wie viele
                      Einwandererkinder: mit radikal schneller Anpassung. Sie
                      lernte in Rekordzeit Schweizerdeutsch. Nach drei Monaten
                      verstand sie praktisch alles, nach sechs Monaten erkannte
                      man in ihrem Rheintaler Dialekt keinen Akzent mehr.
                    </p>
                    <p>
                      «Schon nach drei Wochen schrieb ich einen Sechser in
                      Mathe», erzählt sie. «Da wusste ich: Ich bin angekommen.
                      Ich bin eine von denen.»
                    </p>
                    <p>
                      Die Mutter tat sich schwerer. Sie sprach Deutsch, ihr
                      Akzent verriet sie jedoch als Ausländerin. Aber auch sie
                      besann sich ihrer mährischen Anpassungsfähigkeit und
                      änderte den Nachnamen ihrer Tochter von Hingisová in das
                      schweizerischere Hingis.
                    </p>
                    <p>
                      In dieser Zeit hatte die Tochter zwei Anker: ihre Mutter
                      und das Tennis. Allerdings war die Schweiz nicht
                      vorbereitet auf ein achtjähriges Wunderkind. An vielen
                      Turnieren gab es für sie gar keine Kategorie, sie spielte
                      gegen Jugendliche, auch mal gegen Hausfrauen.
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/02-kindheit-tennis.mp4')}
                        posterImage={require('../../videos/02-kindheit-tennis.jpg')}
                        caption='«Ich kann mich nicht erinnern, je ausgeschlafen zu haben»: Martina Hingis als Zehnjährige. Material: <a href="https://www.srf.ch/play/tv/glanz--gloria-clip/video/das-sportmagazin-time-out-berichtet-erstmals-ueber-das-jungtalent-martina-hingis-time-out-vom-12-11-1990?urn=urn:srf:video:b89070f5-6430-4ddc-af27-7b927ec19b4c">SRF «Time Out»</a>'
                      />
                    </SideElement>
                    <p>
                      «Die dachten: ‹Jööö, wie herzig, ein kleines Mädchen› und
                      wollten mir den Ball sanft zuspielen», erinnert sich
                      Hingis. «Doch sie merkten dann schnell, dass man dem
                      Mädchen den Ball nicht sanft zuzuspielen braucht.»
                    </p>
                    <p>
                      Das herzige Mädchen mit dem unwirklichen Ballgefühl und
                      dem humorlosen Return war aber nicht nur ein verspieltes
                      Naturtalent. Martina Hingis trainierte. Viel. «Ich kann
                      mich nicht erinnern, je ausgeschlafen zu haben», sagt sie.
                      «Wir haben jeden Tag trainiert, jeden Tag. Als Kind denkst
                      du schon mal: ‹Am Sonntagmorgen gibts doch diese
                      Kindersendung im Fernsehen – könnte ich nicht
                      vielleicht …?› Aber nicht für mich.»
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-2-privat.jpg'
                          : '../../images/4-2-privat.jpg')}
                      />
                      <figcaption>
                        Hohe Assimilationsfähigkeit: Bei einem OVO-Grand-Prix in
                        Wangs, Kanton St. Gallen. Foto: Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      Zugleich wusste Melanie Molitor, dass Tennis ein
                      einseitiger Sport ist, also sorgte sie für Abwechslung.
                      Sie gingen wandern, biken, skaten am Rhein und im Winter
                      zum Skifahren nach Wildhaus. Bei diesen Ausflügen lernte
                      die Mutter viel über die Unterschiede zwischen der ČSSR
                      und der Schweiz: «Als ich die vielen Kinder sah, die an
                      Schweizer Skiliften Schlange standen, sagte ich meinen
                      Freunden in Rožnov: ‹Hört auf mit Skifahren, ihr habt
                      sowieso keine Chance.›»
                    </p>
                    <p>
                      Martina Hingis hatte aus demselben Grund schon früh
                      verinnerlicht, wie gut sie war: «Ich war in meinem
                      Jahrgang mit Abstand die beste Tennisspielerin der
                      Tschechoslowakei. Und von dort stammten einige der besten
                      Tennisspielerinnen der Welt. Klar, dass ich dachte, ich
                      könnte es auch an die Spitze schaffen. In der Schweiz
                      denkt von einem Juniorenmeister im Skifahren auch niemand,
                      er habe ein ungesundes Selbstvertrauen, wenn er davon
                      spricht, Weltspitze werden zu wollen.»
                    </p>
                    <p>
                      Einmal sagen wir zu Martina Hingis: «Das ist eine etwas
                      hypothetische Frage, aber wären Sie überhaupt
                      Tennisspielerin geworden, wenn Sie in der Schweiz zur Welt
                      gekommen wären?»
                    </p>
                    <p>
                      «Das ist überhaupt keine schwierige Frage», antwortet sie.
                      «Ich wäre ganz bestimmt nicht Tennisspielerin geworden.
                      Vielleicht Skifahrerin. Wohl eher Bankerin. Warum hätte
                      ich auch Tennisspielerin werden sollen? Der Traum, die
                      Welt zu sehen, lässt sich als Bankerin leichter umsetzen.»
                    </p>
                    <p>
                      Spielerisch fuhr sie in der Schweiz fort, wo sie in der
                      ČSSR aufgehört hatte: Sie schlug als Achtjährige
                      Zwölfjährige und gewann mit zehn erstmals gegen ihre
                      Mutter. Sie spielten beide für den TC Grabs in der
                      untersten Liga. Vom Niveau der Gegnerinnen gelegentlich
                      unterfordert, verglichen sie, wer von ihnen ihr Spiel
                      schneller gewann.
                    </p>
                    <p>
                      Dann war Martina Hingis alt genug für internationale
                      Turniere.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-2' id='section-4-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 5</h6>
                    <h5>Zwei Mädchen erobern Europa</h5>
                    <p>
                      Tarbes, ein Städtchen am Fuss der französischen Pyrenäen,
                      ist für europäische Tennistalente, was Wimbledon für die
                      Profis ist. Das Turnier «Les Petits As» gilt als
                      Meilenstein auf dem Weg zum Tennisstar. Wer sich hier
                      durchsetzt, weiss: Die Richtung stimmt.
                    </p>
                    <p>
                      Michael Chang, Rafael Nadal, Andy Murray, Anna Kurnikowa,
                      Kim Clijsters, Justine Henin, Lindsay Davenport – sie alle
                      gewannen das Turnier oder erreichten den Final. Die erste
                      Spielerin, die in beiden Jahren siegte, in denen sie
                      teilnehmen durfte: Martina Hingis.
                    </p>
                    <p>
                      Die Anfangszeit von Hingis hat die drei Jahre ältere Joana
                      Czapalla miterlebt. Damals war sie, unter ihrem
                      Mädchennamen Manta, eine der grossen Tennishoffnungen der
                      Schweiz, heute führt sie eine Sandwich-Bar mit Filialen in
                      Winterthur und im Glattzentrum. Wir erreichen sie nach
                      mehreren erfolglosen Versuchen auf dem Bürotelefon.
                    </p>
                    <p>
                      «Wir sind immer zusammen gereist, ich mit meinem Vater,
                      Martina mit ihrer Mutter», erzählt sie. «Meistens waren
                      wir im Zug unterwegs, wir hatten Brot und Käse dabei.
                      Geschlafen haben wir in einfachen Hotels. Uns hat das
                      nicht gestört, wir wollten einfach Tennis spielen. Am
                      meisten blieb mir Tarbes in Erinnerung, es hatte viel
                      Publikum, alles war sehr professionell. Wir hatten das
                      Gefühl, zu den Grossen zu gehören.»
                    </p>
                    <p>
                      In Tarbes zu gewinnen, garantiert allerdings nicht, dass
                      man den Weg zu Ende gehen wird. Es siegten dort auch
                      Spielerinnen, von denen man danach nie wieder etwas gehört
                      hat: Nicole London etwa, Stephanie Mabry oder Heike Rusch.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-3-privat.jpg'
                          : '../../images/4-3-privat-desktop.jpg')}
                      />
                      <figcaption>
                        Mit elf gewinnt Martina Hingis in Genua ein Turnier für
                        Vierzehnjährige – und erhält als Prämie eine Vespa.
                        Ebenfalls im Bild: Ihre Freundin Joana Manta. Foto:
                        Privat
                      </figcaption>
                    </SideElement>
                    <p>
                      «Es war klar, dass Martina viel besser ist als wir»,
                      erinnert sich Joana Czapalla. «Sie war eine
                      Ausnahmeerscheinung, aber da steckte auch viel Arbeit
                      dahinter. Die Leute sahen immer nur das Wunderkind. Aber
                      das gibt es nicht. Es gibt keine Wunderkinder. Es gibt nur
                      Talente, die sehr hart arbeiten.»
                    </p>
                    <p>
                      Wegen einer Knieverletzung musste Czapalla 1996
                      zurücktreten, während Hingis gerade ihre ersten
                      Profiturniere gewann. Die Wege trennten sich, doch
                      Czapalla fühlte sich Hingis auch aus der Distanz
                      verbunden. «Was wir hatten, war speziell», sagt sie. «Wir
                      hatten es gut, als wir zusammen unterwegs waren. Das war
                      schön, denn normalerweise hast du keine Freundinnen im
                      Profitennis.»
                    </p>
                    <p>
                      Aber auch Martina Hingis bedeutete es viel, in der Schweiz
                      eine Spielerin zu finden, die ähnlich leidenschaftlich
                      Tennis lebte. Sie spricht von der Zeit mit Joana Czapalla
                      emotionaler als von Turniersiegen als Profi, erinnert sich
                      an ein Gefühl von Unbeschwertheit und Sicherheit. Es waren
                      erlebnisreiche Jahre. Zwei Mädchen entdeckten Europa. In
                      Genua gewann Hingis mit elf ein Turnier, bei dem sonst
                      Vierzehnjährige siegten, und erhielt als Prämie eine
                      Vespa.
                    </p>
                    <p>
                      Tennis war im Jahr 1992, als Hingis zum zweiten Mal in
                      Tarbes gewann, der finanziell lukrativste Sport für
                      Frauen. Für einen Sieg am US Open gab es umgerechnet über
                      eine halbe Million Franken. Die bestverdienende
                      Schweizerin im Ski-Weltcup im gleichen Jahr war Vreni
                      Schneider, sie verdiente über die ganze Saison ein
                      Preisgeld von 79’000 Franken. Es war auch das Jahr, als
                      Jennifer Capriati im Alter von sechzehn Jahren Steffi Graf
                      an den Olympischen Spielen schlug und die achtzehn Jahre
                      alte Monica Seles die Nummer 1 der Welt wurde.
                    </p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/03-roland-garros-1993.mp4')}
                        posterImage={require('../../videos/03-roland-garros-1993.jpg')}
                        caption='Die jüngste Siegerin der Geschichte: Am Juniorinnenturnier des French Open 1993. Material: <a href="https://www.srf.ch/play/tv/glanz--gloria-clip/video/mit-martina-hingis-am-french-open-final-der-danen-juniorinnen-time-out-vom-7-6-1993?urn=urn:srf:video:a1fa6056-5c56-4659-9430-bc262eaa8887">SRF «Time Out»</a>'
                      />
                    </SideElement>
                    <p>
                      Sponsoringfirmen und Vermarktungsagenturen suchten das
                      nächste «Wunderkind». IMG, einer der weltweit grössten
                      Sportvermarkter, kontaktierte Melanie Molitor ein erstes
                      Mal 1990, um ihre Tochter unter Vertrag zu nehmen. Da war
                      Martina Hingis zehn. Melanie Molitor lehnte ab.
                    </p>
                    <p>
                      Für sie war alles neu. Sie lernte dauernd dazu, behielt
                      aber die Grundhaltung bei, die der Kommunismus sie gelehrt
                      hatte: Immer misstrauisch bleiben. Lieber dreimal nein als
                      einmal zu oft ja sagen.
                    </p>
                    <p>
                      So kam es, dass sie die Avancen von IMG zwei Jahre lang
                      ausschlug, so wie sie in der ČSSR bereits Angebote eines
                      Herstellers von Tennisschlägern abgelehnt hatte. Sie
                      glaubte, ein Vertrag würde auf ihre Tochter zu viel Druck
                      ausüben. Was, wenn die Karriere nicht hielt, was sie
                      versprach? Muss sie dann das Geld zurückzahlen?
                    </p>
                    <p>
                      Auch der Schweizer Tennisverband offerierte Hilfe,
                      Privatpersonen wollten Geld investieren. Aber häufig waren
                      die Angebote an die Bedingung geknüpft, dass sich die
                      Mutter als Trainerin zurückzog. Man traute ihr nicht zu,
                      Hingis gross rauszubringen. Und zeigt nicht genau das
                      exemplarisch, wie viel Misstrauen in der Schweiz allem
                      Fremden entgegengebracht wird?
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-3' id='section-4-3'>
                <div className='ta text'>
                  <div className='ui text container'>
                    <h6>Kapitel 6</h6>
                    <h5>
                      Die Schweiz tut sich schwer mit erfolgreichen Frauen
                    </h5>
                    <p>
                      Wir sprechen mit Damir Skenderovic, Professor für
                      Zeitgeschichte an der Universität Freiburg. Sein
                      Schwerpunkt ist historische Migrationsforschung. Wir
                      wollen von ihm wissen, warum die Schweiz mit Martina
                      Hingis und Melanie Molitor nie richtig warm wurde.
                    </p>
                    <p>
                      «Ich glaube, da muss man ein wenig ausholen», antwortet
                      Skenderovic.
                    </p>
                    <SideElement side='right'>
                      <div className='quote-element'>
                        <p className='quote'>
                          «Bei Hingis kamen drei Diskriminierungsebenen
                          zusammen: Herkunft, Geschlecht, Fähigkeit.»
                          <div className='person'>Damir Skenderovic</div>
                        </p>
                      </div>
                    </SideElement>
                    <p>
                      «Von 1945 bis 1989 waren die Menschen aus Osteuropa in der
                      Schweiz willkommen. Sie kamen in drei Phasen: Jene aus
                      Ungarn 1956, jene aus der ČSSR 1968, jene aus Polen und
                      Jugoslawien in den 1980er-Jahren. Es waren teilweise
                      politische Flüchtlinge, gut ausgebildete Leute,
                      Bauarbeiter, Spitalangestellte. Sie waren tüchtig, lernten
                      schnell Deutsch. Sie waren unauffällige und somit
                      gerngesehene Ausländerinnen und Ausländer. Die Frage, ob
                      jemand aus politischen oder wirtschaftlichen Gründen
                      flüchtet, stellte man damals nicht. Das änderte sich mit
                      dem Fall des Eisernen Vorhangs. Jetzt kamen Personen, die
                      nicht vor einem totalitären Regime flohen. Sie suchten in
                      der Schweiz bessere Lebensbedingungen. Und ihnen begegnete
                      man mit Skepsis.»
                    </p>
                    <p>
                      Hingis und Molitor kamen in einer Zwischenphase, nur ein
                      Jahr vor dem Ende des Ostblocks. Sie waren durch die
                      Spezialisierung der Tochter eigentlich
                      Eliteimmigrantinnen, die man gern aufnahm. Wieso wurden
                      die beiden trotzdem als anders und fremd wahrgenommen?
                    </p>
                    <p>
                      «In den Sozialwissenschaften», sagt Damir Skenderovic,
                      «spricht man von Intersektionalität, wenn sich
                      verschiedene, oft unterschiedlich ausgeprägte
                      Diskriminierungsaspekte überschneiden. Jeder für sich
                      genommen hat bereits Auswirkungen, aber sie verstärken
                      sich gegenseitig und werden irgendwann zu einer schweren
                      Belastung. Mir scheint, bei Hingis kamen drei solche
                      Diskriminierungsebenen zusammen: Herkunft, Geschlecht,
                      Fähigkeit.»
                    </p>
                    <div className='quote-element'>
                      <p className='quote'>
                        «Wenn Männer sich wehren, sind sie meinungsstark, wenn
                        Frauen es tun, sind sie Zicken.»
                        <div className='person'>Damir Skenderovic</div>
                      </p>
                    </div>
                    <p>
                      <b>Erstens: Herkunft.</b> Hier geht es zunächst darum, wer
                      überhaupt Schweizer:in sein darf und wer nicht. Doch mit
                      der Einbürgerung und dem Beginn ihrer Tenniskarriere
                      verschob sich bei Hingis das Herkunftsthema. Die Frage war
                      nicht mehr, ob sie dazugehört. Die Frage war nun, ob sie
                      die Schweiz gebührend repräsentiert. Ob die Art, wie sie
                      in der Öffentlichkeit auftrat, dem entsprach, wie sich die
                      Schweiz selbst sah. Skenderovic sagt: «Martina Hingis war
                      selbstbewusst, trotzig und sehr erfolgreich. Das entsprach
                      nicht unbedingt den Erwartungen, die man in der Schweiz an
                      das Auftreten von jungen Menschen in der Öffentlichkeit
                      hatte, und für dieses aufmüpfige Verhalten wurde sie in
                      gewisser Weise bestraft.»
                    </p>
                    <p>
                      <b>Zweitens: Geschlecht.</b> Das Thema ist oft subtiler
                      als die Herkunftsfrage, schwieriger zu benennen. Weder
                      Martina Hingis noch ihre Mutter erzählen von direkten
                      Anfeindungen, und doch lesen wir in Artikeln und
                      Leserbriefen immer wieder abwertend von der
                      «alleinerziehenden», «überehrgeizigen», «strengen» Mutter.
                      Und als man Martina Hingis finanziell unterstützen wollte,
                      allerdings unter der Bedingung, dass sie ohne ihre Mutter
                      weitermacht: Traute man da der Mutter nicht, weil sie eine
                      Frau ist?
                    </p>
                    <p>
                      «Viele Frauen, die aus dem Osten kamen, haben solche oder
                      ähnliche Diskriminierungserfahrungen gemacht», sagt
                      Skenderovic. «In Osteuropa hatten sie eine Ausbildung,
                      viele waren an der Universität, die Rolle der Frau in der
                      Gesellschaft war eine andere als hier, auch das
                      Selbstverständnis. Und das prallt dann auf das Schweizer
                      Frauenbild, das im Vergleich hinterherhinkt: Weniger
                      berufstätige Mütter, weniger berufliche Chancen für
                      Frauen.»
                    </p>
                    <p>
                      Martina Hingis wiederum erfuhr die infantilisierende und
                      zugleich sexualisierende Bewertung, die praktisch alle
                      weiblichen Sportstars kennen: «Tennissternchen»,
                      «Prinzessin», «Fräuleinwunder». Als sich dann aber
                      herausstellte, dass sie nicht das brave Mädchen sein
                      wollte, sondern auch mal ihre Meinung sagte, galt sie
                      sofort als rüpelhaft, aufbrausend, frech. «Das ist ein
                      klassischer diskriminierender Geschlechterstereotyp», sagt
                      Skenderovic. «Wenn Männer sich wehren, sind sie
                      meinungsstark, wenn Frauen es tun, sind sie Zicken.»
                    </p>
                    <p>
                      <b>Drittens: Fähigkeit.</b> Skenderovic spricht von einem
                      Anti-Elitarismus in der Schweiz: «Man nahm Martina Hingis
                      paradoxerweise übel, dass sie so gut war. Dass sie ihren
                      Tenniserfolg zu Geld machte, dass sie zu der Elite der
                      Sportmillionärinnen aufstieg und es auch noch zeigte.»
                      Genüsslich beschrieben die Medien, dass sie ihr eigenes
                      Pferd ritt und einen Porsche fuhr, wie sie sich zuerst in
                      Trübbach, Kanton St. Gallen, ein Haus baute, dann eine
                      Villa in Regensdorf, Kanton Zürich, bezog, die «mehr
                      neureichen Prunk als architektonische Schlichtheit
                      ausstrahlt».
                    </p>
                    <p>
                      Der Erfolg von Martina Hingis war geprägt von einer
                      merkwürdigen Gleichzeitigkeit: Sie hatte hochdotierte
                      Werbeverträge in Japan, den USA, Deutschland und Italien,
                      galt als kompatibles, leicht zu vermarktendes Gesicht –
                      erntete dafür in der Schweiz statt Bewunderung aber
                      Verachtung. Überspitzt kann man sagen: Sie war ein
                      globaler Star, aber ein lokaler Loser. Sie war jemand
                      Ausserordentliches in einer Zeit, als man in der Schweiz
                      lieber jemand Ordentliches gehabt hätte.
                    </p>
                    <p>
                      Skenderovic sagt: «Für Migrantinnen und Migranten waren
                      die 1990er-Jahre in Bezug auf Anderssein und
                      Dazugehörigkeit eine schwierige Zeit, besonders für
                      Frauen. Es gab eine kollektive mentale Krise in der
                      Schweiz: Die EWR-Abstimmung, die Diskussionen über die
                      Rolle der Schweiz im Zweiten Weltkrieg, das im Vergleich
                      zu vielen Ländern relativ rückständige Familienbild, die
                      Selbstverortung als provinzielles Land in einer
                      globalisierten Welt. Und dann kommt plötzlich ein Global
                      Player im wahrsten Sinn des Wortes und zeigt einen viel
                      ambitionierteren Weg auf. Hätte es ohne Hingis einen
                      Federer gegeben?»
                    </p>
                    <p>
                      Hingis fiel in der Schweiz die undankbare
                      Scharnierfunktion zwischen dem Gestern und dem Morgen zu.
                      Der Widerstand, den sie erlebte, war der Widerstand der
                      1990er-Jahre-Schweiz gegen den gesellschaftlichen Wandel,
                      der auch vor diesem Land nicht haltmachte.
                    </p>
                    <p>
                      Das macht die Geschichte von Martina Hingis auch zu einer
                      Geschichte der Schweiz und ihres Umgangs mit Spitzensport,
                      mit Migration, mit Frauen.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-4-4' id='section-4-4'>
                <div className='ta text'>
                  <div className='ui text container'>
                    <h6>Kapitel 7</h6>
                    <h5>Eine kurze Hommage an den Tennissport</h5>
                    <p>
                      Der Unterschied zwischen Tennis und Fussball ist der, dass
                      man im Fussball Fehler machen darf. Natürlich entscheiden
                      auch im Fussball manchmal Zentimeter, aber in der Regel
                      kann man auch einen schlecht gespielten Pass irgendwie
                      annehmen, eine verunglückte Flanke erreicht eventuell doch
                      die Mitspielerin, ein Fehlpass im Aufbau führt nicht
                      zwangsläufig zu einem Gegentor.
                    </p>
                    <p>
                      Im Tennis ist das anders. «Wenn Sie zumindest ein wenig
                      Tennis gespielt haben, haben Sie wahrscheinlich eine
                      Vorstellung davon, wie schwer es ist, es gut zu spielen,
                      aber ich behaupte, dass Sie wirklich überhaupt keine
                      Ahnung haben», schrieb David Foster Wallace, selbst ein
                      verhinderter Tennisprofi, dessen schriftstellerisches
                      Genie auch in der Beschreibung seines geliebten Sports
                      Ausdruck fand. «Im Fernsehen kann man nicht wirklich
                      erkennen, was echte Spitzenspieler leisten – wie hart sie
                      den Ball tatsächlich schlagen und mit welcher Kontrolle
                      und taktischen Fantasie und Kunstfertigkeit.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/4-5-tennis.jpg'
                          : '../../images/4-5-tennis.jpg')}
                      />
                      <figcaption>
                        Tennis galt lange Zeit als künstlerisch und subversiv.
                        Beide Geschlechter spielten es, oft sogar zusammen.
                        Foto: Pictorial Press Ltd/Alamy Stock Photo
                      </figcaption>
                    </SideElement>
                    <p>
                      Tennis verlange nicht nur absolute Körperkontrolle,
                      Hand-Auge-Koordination, Schnelligkeit, Reaktionsvermögen,
                      Kondition und Mut, sondern auch diesen merkwürdigen,
                      widersprüchlichen Mix aus Vorsicht und
                      Rücksichtslosigkeit. Manchmal muss man geduldig und
                      abwartend spielen, manchmal draufgängerisch und aggressiv.
                      Und das Spiel gehört jenen, die das richtige Mass dafür
                      kennen. Nicht ohne Grund wird Tennis oft mit Schach
                      verglichen. Man ist ähnlich einsam. Plant mehrere Züge im
                      Voraus. Und ist an jedem Fehler, der einem unterläuft,
                      selbst schuld.
                    </p>
                    <p>
                      Es zählt auch nur der Sieg. Wer im Final knapp verliert,
                      wird nicht Zweite:r, Halbfinalist:innen belegen nicht die
                      Plätze 3 und 4. Der Weg ist im Tennis nie das Ziel. Nur
                      das Ziel ist das Ziel.
                    </p>
                    <p>
                      Vielleicht ist es durchaus bezeichnend, dass die erste
                      historische Darstellung von Tennis ein Bild aus der Hölle
                      ist: Ein Abt des Klosters Morimond im heutigen
                      Fresnoy-en-Bassigny soll Ende des zwölften Jahrhunderts
                      beobachtet haben, wie sich Dämonen eine Menschenseele wie
                      einen Ball mit der flachen Hand zuspielten. Es waren
                      Mönche, die verbotenerweise zwischen den Gebeten im
                      Innenhof eines Klosters einem Ballspiel nachgingen und
                      sich dabei zu Dämonen verwandelten. Der Abt beschrieb die
                      Szene einem Freund, der sie wiederum dem
                      Zisterziensermönch Caesarius von Heisterbach
                      weitererzählte, der die Szene in seinem Werk «Dialogus
                      miraculorum» festhielt.
                    </p>
                    <p>
                      Das frevelhafte Ballspiel hiess auf Französisch «Jeu de
                      Paume» («Spiel mit der Handinnenfläche») und war eine Art
                      Tennis ohne Netz und Schläger. Mit den Jahren fand es
                      seinen Weg aus den Klöstern in die Höfe der Adligen. Statt
                      mit der Hand spielte man den Ball nun mit einem Handschuh
                      und bald mit einem Schläger, trennte das Feld durch ein
                      Netz und begrenzte es mit Linien. Das Wort Racket, dies
                      nur am Rande, stammt vom Arabischen «rakhat» und bedeutet
                      ebenfalls Handinnenfläche.
                    </p>
                    <p>
                      Aber woher der Name des Spiels selbst – Tennis? Die
                      Etymologie ist rätselhaft. Eine Erklärung könnte sein,
                      dass man in Frankreich vor jedem Service «Tenez!» rief,
                      Französisch für «Nimm das!», eine Art Warnung im Sinne
                      von: «Hier kommt der Ball». Bis heute «warnen» wir unsere
                      Gegner:innen, indem wir vor dem Aufschlag kurz den
                      Spielstand übers Netz rufen (auch, um Diskussionen über
                      den Spielstand <i>vor</i> dem Ballwechsel auszutragen,
                      nicht danach).
                    </p>
                    <p>
                      Durch Lautverschiebung entstand im Italienischen «tenys»
                      und schliesslich das englische «Tennis». Damals war es
                      noch ein Teamsport, die mentale Brutalität aber muss der
                      heutigen geähnelt haben, denn in einer mittelalterlichen
                      Ballade von 1536 verglich der Mönch John Lydgate die
                      Schlacht von Azincourt während des Hundertjährigen Kriegs
                      mit einem Tennisspiel.
                    </p>
                    <p>
                      Überall an den europäischen Adelshöfen baute man in der
                      Folge «Ballhäuser», in denen der Sport ausgeübt wurde. In
                      einem solchen kam es in Paris am 20. Juni 1789 zum
                      legendären Ballhausschwur, dem «Serment du Jeu de Paume»,
                      einem der entscheidenden Ereignisse der Französischen
                      Revolution: Der dritte Stand – bestehend aus Bürgertum,
                      Bauern und Handwerkern – schwor, «sich niemals zu trennen,
                      bis der Staat eine Verfassung hat (…), und nur der Gewalt
                      der Bajonette zu weichen». Wer sagt, Tennis sei mehr als
                      ein Spiel, hat also nicht unrecht.
                    </p>
                    <p>
                      Der Sport entwickelte sich aber nicht nur in den
                      Ballhäusern der Oberschicht, sondern auch auf öffentlichen
                      Plätzen als «Strassentennis» und in Schuldnergefängnissen
                      als «Racketsport», einer Art Vorläufer des heutigen
                      Squash.
                    </p>
                    <p>
                      Das moderne Tennis entstand durch zwei sehr
                      unterschiedliche, aber zeitliche nah beieinanderliegende
                      Entwicklungen: 1830 erfand Edwin Budding den Rasenmäher.
                      1839 entdeckte Charles Goodyear die Vulkanisierung. Erst
                      dadurch war es möglich, Bälle herzustellen, die
                      unempfindlich gegenüber Feuchtigkeit und Schmutz waren und
                      trotzdem gute Sprungeigenschaften hatten. Und dank des
                      Rasenmähers konnte man das Spiel von den unebenen
                      Sandböden auf den gleichmässig gestutzten Rasen verlegen.
                    </p>
                    <p>
                      Die meisten populären Sportarten im damaligen
                      viktorianischen Grossbritannien waren rohe oder steife
                      Angelegenheiten wie Rugby, Cricket und Fussball. Tennis
                      hingegen war künstlerisch und subversiv. Beide
                      Geschlechter spielten es, oft sogar zusammen. Ein
                      Tennisspiel wurde nicht mit Kraft und Ausdauer gewonnen,
                      man siegte durch Geschicklichkeit. Langsam entwickelten
                      sich auch Regelwerke und Meisterschaften, und man begann,
                      Ergebnisse und Rekorde festzuhalten – etwas, das im
                      Mittelalter und in der Renaissance völlig unbedeutend
                      gewesen war.
                    </p>
                    <p>
                      Ein Major namens Walter Clopton Wingfield brachte
                      schliesslich eine bis heutige gültige Akribie in den
                      Sport, er machte aus dem vogelfreien Spektakel ein
                      geschlossenes System, dessen Regeln streng befolgt werden.
                      Übertretungen werden nicht nur angezeigt, man ruft sie
                      laut aus: «Out!»
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-5' id='section-5'>
                <SegmentHeader
                  part='Dritter Teil'
                  title='An der Spitze'
                  image={require(isMobile
                    ? '../../images/5-wimbledon.jpg'
                    : '../../images/5-wimbledon-desktop.jpg')}
                  caption='Foto: Chris Smith (Popperfoto/Getty Images)'
                />
              </Element>

              <Element className='section' name='section-5-1' id='section-5-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 8</h6>
                    <h5>Das unglaubliche Jahr 1997</h5>
                    <p>
                      Als Martina Hingis am 4. Oktober 1994 in Zürich auf der
                      Profitour der Women’s Tennis Association (WTA) debütierte,
                      war sie gerade vierzehn Jahre alt geworden. Ihre Gegnerin,
                      eine um fünfzehn Jahre ältere Amerikanerin, hiess Patty
                      Fendick und war die Nummer 45 der Weltrangliste. Nummer 45
                      klingt nach nichts, aber es bedeutet, dass auf der ganzen
                      Welt nur vierundvierzig Frauen besser sind als du. Seit
                      mehr als einem Jahr diskutierte die Tennisszene eine Frage
                      besonders heftig: Welches Mindestalter sollte eine
                      Spielerin haben, um zur Tour zugelassen zu werden?
                    </p>
                    <p>
                      Im Frühling 1993 hatte Hingis als jüngste Spielerin der
                      Geschichte den Juniorinnenwettbewerb des
                      Grand-Slam-Turniers in Paris gewonnen. Sie war zwölf, ihre
                      Gegnerin achtzehn. Die französische Zeitung «Le Monde»
                      schrieb: «Sie ist kleiner als die Mädchen, die ihr auf dem
                      Tennisplatz die Bälle holen. Man könnte schwören, dass sie
                      Schwierigkeiten hat, ihren Schläger hochzuheben. Aber sie
                      spielt und gewinnt mit einer verblüffenden Hellsicht.»
                    </p>
                    <p>
                      Skeptisch über die schon zu ihrer Nachfolgerin
                      stilisierten Schweizerin äusserte sich auch die
                      sechsunddreissig Jahre alte Martina Navrátilová, die
                      Namensgeberin von Hingis: «Meinem zwölfjährigen Kind würde
                      ich das nicht zumuten. Das ist eine Erwachsenenwelt, und
                      mit zwölf Jahren ist es verdammt schwierig, damit
                      umzugehen. Es ist zu früh. Es ist zu viel Druck.»
                    </p>
                    <p>
                      Navrátilová war da längst eine Ikone, auf dem Platz ebenso
                      wie daneben. In den frühen 1980er-Jahren hatte sie sich
                      als einer der ersten Sportstars als homosexuell geoutet,
                      zwischen 1978 und 1990 gewann sie im Einzel achtzehn
                      Grand-Slam-Titel. Was sie sagte, wurde gehört.
                    </p>
                    <p>
                      Auf Navrátilovás Urteil angesprochen, erwiderte die
                      zwölfjährige Martina Hingis: «Ich urteile nicht über sie,
                      warum urteilt sie über mich? Ich denke nicht, dass sie zu
                      alt zum Spielen ist. Warum denkt sie, ich sei zu jung?» So
                      clever die Antwort scheinen mag, natürlich lag Navrátilová
                      nicht völlig daneben: 1990 hatte Jennifer Capriati kurz
                      vor ihrem vierzehnten Geburtstag eine Sondergenehmigung
                      erhalten, um Profi zu werden. Die halbe Welt schaute ihr
                      in den Jahren danach dabei zu, wie sie ihre Jugend im
                      Scheinwerferlicht der Öffentlichkeit nachholte, beim
                      Ladendiebstahl und Haschischbesitz erwischt wurde, mit
                      Depressionen kämpfte und schliesslich ihre Karriere
                      vorzeitig beendete.
                    </p>
                    <p>
                      Dass Hingis spielerisch mit den Profis mithalten konnte,
                      war nicht die Frage. Die Frage war, ob ein Mädchen ihres
                      Alters seelisch für die Anforderungen der Tour gerüstet
                      war.
                    </p>
                    <p>
                      Nein, fand ihre Mutter damals, 1993. Ein Jahr später, sie
                      war inzwischen dreizehn, wiederholte Hingis ihren Triumph
                      in Paris und gewann den Grand-Slam-Titel der Juniorinnen
                      in Wimbledon. Jetzt ist sie bereit, urteilte ihre Mutter.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-1-paris_1994.jpg'
                          : '../../images/5-1-paris_1994-desktop.jpg')}
                      />
                      <figcaption>
                        «Sie ist kleiner als die Mädchen, die ihr auf dem
                        Tennisplatz die Bälle holen. Aber sie spielt und gewinnt
                        mit einer verblüffenden Hellsicht», schrieb 1993 «Le
                        Monde». Foto: Keystone/Interfoto/Lookback
                      </figcaption>
                    </SideElement>
                    <p>
                      Uns sagt sie: «Ich fand das ganze Theater völlig
                      übertrieben. Martina war die beste Juniorin der Welt,
                      warum sollte sie nicht gegen Erwachsene spielen können?
                      Vielleicht würde sie verlieren, vielleicht würde sie
                      gewinnen – das weiss man vorher nicht.»
                    </p>
                    <p>
                      Am 4. Oktober 1994 also betrat Martina Hingis den Court
                      der Zürcher Saalsporthalle, um gegen Patty Fendick ihr
                      erstes Profimatch zu spielen. Auf der Tribüne sassen
                      tausende Neugierige, zudem Journalist:innen aus aller
                      Welt. Die meisten dachten wohl, Hingis würde nun auf den
                      Boden der Realität zurückgeholt. Wie die zwei Balljungen,
                      etwas jünger als Hingis, die das Schweizer Fernsehen vor
                      dem Spiel befragte: «Ich glaube, dass sie verliert. Es
                      wird sicher ein schönes Match, aber sie hat wenig
                      Chancen», sagte der eine. «Ich glaube auch, dass sie
                      verliert. Sie ist sicher ein Talent für ihr Alter, aber
                      das waren schon viele», sagte der andere.
                    </p>
                    <p>
                      Mit auffällig erhobenem Haupt schaute sich Hingis um,
                      nachdem sie gemeinsam mit Fendick den Platz betreten
                      hatte. Nicht arrogant, eher erwartungsfroh. Das Spiel aber
                      begann wie von den meisten angenommen: Hingis verlor
                      gleich ihren ersten Service. Sie wirkte fahrig und nervös.
                      Doch langsam, beinahe unmerklich veränderte sich etwas.
                    </p>
                    <p>
                      Hingis schlug die Bälle nicht härter als Fendick, sie
                      machte keine direkten Punkte und diktierte auch das Spiel
                      nicht. Dazu fehlten ihren Schlägen die Kraft und die
                      Präzision. Aber sie durchschaute Fendicks Pläne und
                      verführte die viel erfahrenere Gegnerin zu Fehlern. Sie
                      spielte noch nicht spektakulär, sie machte einfach im
                      richtigen Moment den richtigen Schlag. Schon zu diesem
                      frühen Zeitpunkt sah man ihr Markenzeichen: Sie bewegte
                      sich auf dem Platz mit der Grazie einer Tänzerin, und sie
                      spielte mit der Gerissenheit einer Trickdiebin.
                    </p>
                    <p>Hingis gewann in 66 Minuten 6:4, 6:3.</p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/05-wimbledon-1996.mp4')}
                        posterImage={require('../../videos/05-wimbledon-1996.jpg')}
                        caption='Der erste Grand-Slam-Sieg: 1996 im Doppel mit Helena Suková. Material: Wimbledon'
                      />
                    </SideElement>
                    <p>
                      Es ist wichtig, daran zu erinnern, dass ihr trotz ihrer
                      Begabung nicht alles auf Anhieb gelang. Gleich ihr
                      nächstes Spiel gegen Mary Pierce verlor sie. Und viele
                      weitere auch. Es dauerte zwei Jahre, bis sie ihre ersten
                      Turniere gewann, im Juli 1996 in Wimbledon im Doppel an
                      der Seite Helena Sukovás – was sie zur jüngsten
                      Grand-Slam-Siegerin der Geschichte machte – und im Oktober
                      in Filderstadt dann im Einzel.
                    </p>
                    <p>
                      Den zwei Erfolgen war ein Zerwürfnis zwischen Mutter und
                      Tochter vorausgegangen. Im März 1996 in Key Biscayne,
                      Florida, hatte Hingis so gelangweilt und gleichgültig ihr
                      Auftaktspiel gegen eine um 85 Weltranglistenplätze
                      schlechter klassierte Gegnerin verloren, dass Melanie
                      Molitor ihrer Tochter ein Ultimatum stellte:
                      Tenniskarriere oder zurück in die Schule (die Hingis mit
                      vierzehn verlassen hatte).
                    </p>
                    <p>
                      «Das war ein Wendepunkt», sagt Martina Hingis. «Wir waren
                      nicht sehr zufrieden miteinander.»
                    </p>
                    <p>
                      Und Melanie Molitor sagt offen: «Wenn die Kinder klein
                      sind, kann man sich als Mutter nicht vorstellen, dass mit
                      der Pubertät einmal solche Probleme kommen. Wir stritten
                      uns über Monate. Ich hatte einfach nicht kommen sehen,
                      dass es Martina einmal viel wichtiger sein würde, ein
                      selbstständiger Mensch statt eine gute Tennisspielerin zu
                      sein. Davor war sie von mir beeinflusst gewesen, jetzt
                      hatte sie eine Persönlichkeit, wollte nicht trainieren.
                      Sie dachte, der Erfolg stelle sich auch so ein. Ich musste
                      ihr klar machen, dass Tennis nie die wichtigste Sache für
                      mich gewesen war. Ich sah Tennis bloss als Chance, dass
                      sie ein gutes Leben hat. Ich sagte ihr, dass sie diese
                      Chance nicht ergreifen müsse, dass ich sie immer lieben
                      werde. Ich sagte: ‹Ich habe dich Tennis gelehrt, aber wenn
                      du das nicht machen willst, hast du in der Schweiz viele
                      andere Möglichkeiten. Dann spiele nicht.›»
                    </p>
                    <p>
                      Hingis sagte nicht viel – sie sagt nie viel in wichtigen
                      Momenten –, aber sie verstand. Sie erhöhte ihr tägliches
                      Trainingspensum von 1,5 auf 2,5 Stunden, fing mit Aerobic
                      und Schattenboxen an.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-2-australien.jpg'
                          : '../../images/5-2-australien.jpg')}
                      />
                      <figcaption>
                        Wer braucht einen Pokal, wenn man ein Plüschtier haben
                        kann? 1997 gewinnt Martina Hingis mit sechzehn Jahren
                        zum ersten Mal das Australian Open. Foto: Eddy Risch
                      </figcaption>
                    </SideElement>
                    <p>
                      Es folgten: Halbfinal am US Open, der Turniersieg in
                      Filderstadt, Final in Zürich, Halbfinal in Chicago, Sieg
                      in Oakland.
                    </p>
                    <p>
                      Und dann: Das unglaubliche Jahr 1997. Im Januar in
                      Melbourne gewann Martina Hingis als jüngste Spielerin des
                      zwanzigsten Jahrhunderts das Australian Open. Am 31. März
                      rückte sie als jüngste Spielerin der Geschichte auf Platz
                      1 der Weltrangliste vor. Im Juli gewann sie Wimbledon, im
                      September das US Open. Von den vier Grand-Slam-Turnieren
                      gewann sie in jenem Jahr nur das French Open nicht. Dass
                      sie im Final überraschend gegen Iva Majoli verlor, lag
                      daran, sagt sie, dass «der Tank leer war».
                    </p>
                    <p>
                      1997 war auch das Jahr, in dem Martina Hingis siebzehn
                      wurde. Zum Vergleich: Die derzeitige Weltranglistenerste
                      Ashleigh Barty war dreiundzwanzig, als sie zum ersten Mal
                      ein Grand-Slam-Turnier gewann.
                    </p>
                    <p>
                      Hingis war nun die beste Tennisspielerin der Welt. Doch
                      die Auseinandersetzungen zwischen Mutter und Tochter
                      gingen weiter. Vorübergehend entschied sich Hingis sogar,
                      ohne ihre Mutter auf die Tour zu gehen.
                    </p>
                    <p>
                      «Ich denke, ich wollte ihr zeigen, dass ich es auch ohne
                      sie kann», sagt sie uns über die Alleingänge in den Jahren
                      1998 und 2001. «Oder wollte ich es mir zeigen? Meine
                      Mutter machte sicher keine Freudensprünge, aber sie liess
                      es zu. Wir waren nie zerstritten. Und ich rief sie dann
                      trotzdem nach jedem Match an, sagte: ‹Heeeey, ich habe
                      gewonnen!› Und sie: ‹Ja, ja.› Sie schaute sich am
                      Fernsehen natürlich alle Spiele an, freute sich für mich,
                      aber dachte vermutlich, dass ich mit ihr in den Final
                      vorgestossen wäre, nicht bloss in den Halbfinal. Ich
                      merkte dann schnell, dass es für mich härter war, ohne sie
                      unterwegs zu sein. Es fiel mir schwer, mich selbst zu
                      pushen. Dafür brauchte ich sie.»
                    </p>
                    <p>
                      Nach einer Pause sagt sie: «Am Ende kommt man eben doch
                      immer dorthin zurück, wo es am besten funktioniert. Mir
                      wurde klar, dass meine Mutter der Mensch ist, auf den ich
                      mich in meinem Leben am meisten verlassen kann.» Dass die
                      Verbindung zwischen Martina Hingis und Melanie Molitor
                      über all die Jahre so eng blieb, ist umso bemerkenswerter,
                      wenn man weiss, wie viele Leute sich in den 1990er-Jahren
                      den Mund über die Beziehung zerrissen.
                    </p>
                    <p>
                      Wer möchte, kann einen kleinen Test im persönlichen Umfeld
                      machen: Fragen Sie Bekannte, was ihnen zur Mutter von
                      Martina Hingis einfällt. Die Wahrscheinlichkeit ist gross,
                      dass eines der folgenden Wörter fällt: «Tennis-Mami»,
                      «unsympathisch», «verbissen». Befeuert durch unzählige
                      Medienartikel, hat sich ein merkwürdiges Bild von Melanie
                      Molitor im kollektiven Schweizer Bewusstsein eingenistet:
                      das der unbarmherzigen Erzieherin, die ihrer willigen
                      Tochter den eigenen verpassten Traum aufstülpt.
                    </p>
                    <p>
                      Als wir Melanie Molitor mit dem Vorwurf, sie habe ihre
                      Tochter instrumentalisiert, konfrontieren, sagt sie:
                      «Martina war immer frei. Das war mir wichtig. Ich wollte,
                      dass sie frei ist, ich akzeptierte ihre Entscheidungen
                      ohne Umschweife.»
                    </p>
                    <p>
                      Es verhielt sich also genau umgekehrt: Molitor wollte
                      nicht Hingis nach ihren Vorstellungen formen, sie wollte,
                      dass die Persönlichkeit der Tochter auch auf dem Platz zum
                      Ausdruck kommt. «Wie du lebst, so spielst du», sagt sie
                      uns. Was sie meint: Wenn wir die Frechheit und den
                      Spielwitz von Martina Hingis auf dem Platz lieben, müssen
                      wir auch ihre Unangepasstheit abseits des Platzes
                      anerkennen. Es gibt das eine nicht ohne das andere.
                    </p>
                    <p>
                      Vielleicht ist das der Unterschied zu Andre Agassi oder
                      Tracy Austin, die ebenfalls als Teenager Profis wurden,
                      gezwungen von den Eltern, und die trotz aller Erfolge am
                      Tennis litten wie an einer schweren Krankheit und die
                      erleichtert waren, als es vorüber war: Martina Hingis ist
                      noch heute nirgends lieber als auf dem Tennisplatz.
                    </p>
                    <p>
                      Das ist natürlich einer der plattesten Sätze, den man über
                      Sport schreiben kann. Die Sache ist bloss: Er stimmt.
                      Während unserer Recherche treffen wir Martina Hingis immer
                      wieder auch an tennisnahen Orten: In Zug spielt sie
                      Interclub mit drei alten Freundinnen, in Biel ist sie
                      Coach des Schweizer Fedcup-Teams, in der Tennishalle von
                      Melanie Molitor in Wollerau trainiert sie mit Schülerinnen
                      ihrer Mutter. Mit dem Racket in der Hand wirkt sie
                      befreit. Tennis war für sie vielleicht tatsächlich keine
                      Belastung, sondern ein grosses Glück.
                    </p>
                    <p>
                      Und ist es immer noch. Wenn sie auf dem Platz steht, ist
                      das keine wehmütige Erinnerung an früher, kein
                      verzweifelter Versuch, an vergangene Triumphe anzuknüpfen.
                      Sie ist wirklich einfach nur da. Schaut nicht zurück und
                      nicht nach vorne, hat keine Erwartungen. Sie betritt den
                      Platz und geniesst das Spiel.
                    </p>
                    <p>
                      1997, fünf Jahre nach ihrer Grundsatzkritik, sprach auch
                      Martina Navrátilová anders, nachdenklicher über Martina
                      Hingis. Einer Journalistin der «Sports Illustrated» sagte
                      sie: «Wenn ich eine Tochter hätte, würde ich versuchen,
                      sie davon abzuhalten, so früh so viel zu spielen. Aber die
                      Mutter ist sehr klug mit Martina umgegangen. Sie hat ihr
                      ein Leben ermöglicht. Martina ist eine Tennistochter, aber
                      sie ist in erster Linie eine Tochter.»
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/06-wahnsinnsjahr-1997.mp4')}
                        posterImage={require('../../videos/06-wahnsinnsjahr-1997.jpg')}
                        caption='Ihr bestes Jahr: 1997.'
                      />
                    </div>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-2' id='section-5-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 9</h6>
                    <h5>Warum zählt man im Tennis so komisch?</h5>
                    <p>
                      Tennis ist ein eigenwilliger Sport voller Mysterien und
                      Widersprüchlichkeiten. Allein die Zählweise ist etwas vom
                      Bizarrsten, das man im organisierten Sport finden kann.
                      Sie geht so: Love (das steht für Null), 15, 30, 40,
                      Punktgewinn. Die Punktevergabe orientiere sich, so sagen
                      die einen, an den Viertelstunden einer Uhr. Aber warum
                      dann 40 und nicht 45? Andere behaupten, sie sei abgeleitet
                      von einer Frühform des Tennis, als man bei jedem Punkt 15
                      Fuss vorrückte. Aber 45 Fuss sei zu nah am Netz gewesen,
                      also nur 40.
                    </p>
                    <p>
                      Noch rätselhafter ist die Entstehung von «Love» für Null.
                      Eine Theorie verortet den Ursprung im sechzehnten
                      Jahrhundert, als niederländische Protestant:innen während
                      der Religionskriege nach England flohen und – mittellos,
                      wie sie waren – nicht um Geld, nur um die Ehre spielen
                      konnten («iets voor lof doen»). Eine andere Erklärung geht
                      zurück auf den Umstand, dass die Null wie ein Ei,
                      französisch «l’œuf», aussieht. In Grossbritannien machten
                      sie daraus dann «Love».
                    </p>
                    <p>
                      Beide Theorien scheinen denkbar, aber was wirklich
                      fasziniert: Durch die kryptische Zählweise und die
                      Dreiteilung in Spiel, Satz, Sieg kann man mehr Punkte
                      machen als die Gegnerin – und dennoch verlieren. Es ist
                      das «Simpson-Paradoxon». Am besten verständlich wird es,
                      wenn man sich das Ergebnis 0:6, 7:5, 7:5 ansieht. Hier hat
                      die Unterlegene 16 Spiele gewonnen, die Siegerin nur 14.
                    </p>
                    <p>
                      Auch ist nicht jeder Punkt gleich wichtig. 5:5, 15:30,
                      zweiter Aufschlag – das ist ein dramatischer Punkt. Der
                      Punkt davor ist im Vergleich weniger bedeutend. Zugleich
                      ist es falsch, das Tennis nur anhand von «Big Points» zu
                      betrachten. Denn die wichtigen Punkte bauen auf den
                      vorherigen auf.
                    </p>
                    <p>
                      Oft misst man grosse Champions daran, wie gut sie in den
                      entscheidenden Momenten waren. Dabei geht vergessen, dass
                      der entscheidende Moment auf vielen vorherigen aufbaute.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-3' id='section-5-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 10</h6>
                    <h5>Auch der schwerste Tag geht irgendwann zu Ende</h5>
                    <p>
                      Am 5. Juni 1999 kam es in Paris zu einem langersehnten
                      Duell: Die achtzehn Jahre alte Martina Hingis traf im
                      Final des French Open auf die neunundzwanzig Jahre alte
                      Steffi Graf. Die eine, Martina Hingis, wollte sich den
                      einzigen Grand-Slam-Titel holen, der ihr noch fehlte. Die
                      andere, Steffi Graf, war die grösste Tennisspielerin seit
                      Martina Navrátilová und auf einer Art Abschiedstournee.
                      Sie hatte einundzwanzig Grand-Slam-Titel gewonnen, aber
                      von Verletzungen geplagt seit drei Jahren keinen Final
                      mehr erreicht.
                    </p>
                    <p>
                      Dieses Spiel sollte die Beziehung zwischen Hingis und der
                      Schweizer Öffentlichkeit auf einen neuen Tiefpunkt
                      bringen, doch wir finden in unseren Gesprächen mit ihr
                      lange nicht den Mut, das ihr gegenüber zu thematisieren.
                    </p>
                    <p>
                      (Es gehört zu den vielen Ungereimtheiten des menschlichen
                      Daseins, dass man sich nicht traut, das Naheliegende, das
                      Offensichtliche, das Dringende anzusprechen. Weder mit den
                      eigenen Eltern noch mit der ehemaligen Nummer 1 der
                      Weltrangliste. Die Erklärung dafür ist wohl banal: Wir
                      wollen das Gegenüber nicht verletzen, fürchten einen
                      Konflikt oder den Abbruch der Beziehung.)
                    </p>
                    <p>
                      An einem schönen Herbsttag, wir sitzen im Stübli eines
                      ihrer Lieblingsrestaurants, beginnt Martina Hingis dann
                      plötzlich selbst davon zu reden.
                    </p>
                    <p>
                      «Die Begegnung war über Monate aufgeheizt worden. Es hiess
                      ja immer, ich wäre gar nicht die Nummer 1, wenn Steffi
                      nicht verletzt wäre. Ich wusste, dass die Leute das
                      dachten. Und wollte beweisen, dass sie falsch lagen. Ich
                      hatte Steffi schon dreimal geschlagen, zweimal in Tokio,
                      einmal in Rom, aber dieses Spiel wollte ich so fest
                      gewinnen wie keines zuvor. Ich wollte sie unbedingt
                      schlagen und den Titel holen.»
                    </p>
                    <p>
                      Dass Graf überhaupt in den Final vorgestossen war, mit
                      qualvollen Siegen gegen Lindsay Davenport, die Nummer 2,
                      und Monica Seles, die Nummer 3 der Welt, grenzte schon an
                      ein Wunder. Und nun traf sie auch noch auf die Spielerin,
                      die ihre Nachfolge angetreten hatte.
                    </p>
                    <p>
                      Es war ein Duell zweier sehr unterschiedlicher
                      Generationen und Spielstile: Auf der einen Seite Graf,
                      deren Spitzname «Fräulein Vorhand» sich auf ihren
                      Hauptschlag bezog, der so vernichtend war, dass
                      Gegnerinnen ihr mitunter ein ganzes Spiel lang nur auf die
                      Rückhand spielten. Zudem verfügte sie über eine
                      unglaubliche Beinarbeit und eine fehlerfreie Rückhand, die
                      sie fast ausschliesslich als Slice spielte.
                    </p>
                    <p>
                      Auf der anderen Seite Martina Hingis, die Tennis spielte,
                      als sei das Wort «Ballgefühl» allein für sie erfunden
                      worden. Sie besass die Fähigkeit, Bälle, die andere nur
                      mit grösster Anstrengung erreichen, scheinbar mühelos
                      übers Netz zu spielen. Was anderen schwer fiel, fiel ihr
                      leicht.
                    </p>
                    <p>
                      Diese beiden Antipoden des Sports trafen nun in Paris
                      aufeinander. Hingis war die Favoritin, auch wenn sie Graf
                      noch nie an einem Grand-Slam-Turnier geschlagen hatte.
                    </p>
                    <p>
                      Anfang 1997 hatte Martina Hingis im deutschen Fernsehen
                      gesagt: «Die Steffi ist zu lange raus aus den Turnieren,
                      sie wird es nicht mehr schaffen, oben mitzuspielen». Und:
                      «Die Zeiten haben sich geändert. Nur die Deutschen können
                      das anscheinend nicht akzeptieren.» Es klang grossmaulig,
                      war aber vermutlich bloss ehrlich. Hingis hatte{' '}
                      <i>wirklich</i> das Gefühl, sie sei besser und die Zeit
                      von Graf vorbei.
                    </p>
                    <p>
                      Es gibt zwei Lesarten des Spiels: Die eine kann man in dem
                      Statement von Graf zusammenfassen, die das Spiel im
                      Nachhinein als «den schönsten Moment meiner Karriere»
                      beschrieb. Die andere in den Worten von Martina Hingis,
                      die mit tränenerstickter Stimme auf Französisch zum
                      Publikum sagte: «Ich komme nächstes Jahr wieder, und
                      vielleicht seid ihr ja dann auf meiner Seite.»
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-3-paris-1999.jpg'
                          : '../../images/5-3-paris-1999.jpg')}
                      />
                      <figcaption>
                        Nirgends ist man einsamer als auf dem Tennisplatz. Foto:
                        Al Bello (Staff/Getty Images)
                      </figcaption>
                    </p>
                    <p>
                      Was war geschehen? Das Tournoi de Roland-Garros, so der
                      offizielle Name, bietet im Vergleich zu Wimbledon eine
                      lebendige, farbenfrohe, laute Kulisse. Das Publikum ist
                      den peniblen Regeln des Sports gegenüber recht
                      gleichgültig. Es gibt Zwischenrufe, Anfeuerungen, aber
                      auch Buhrufe; das «Silence, s’il vous plait!» der
                      Schiedsrichter:innen wird gern ignoriert.
                    </p>
                    <p>
                      An diesem sonnigen Samstagnachmittag schien die Mehrheit
                      der 16’000 Zuschauer:innen, die sich für den Final in den
                      Court Philippe Chatrier drängten, eher von der Idee
                      fasziniert, dass eine fünffache French-Open-Siegerin ein
                      letztes Mal an ihrer alten Wirkungsstätte siegt, als dass
                      ein Teenager die Hierarchie durcheinanderbringt.
                    </p>
                    <p>
                      Doch Hingis liess sich kaum beeindrucken. Schon im ersten
                      Game wurde ihr Plan klar: Wie hunderte Spielerinnen vor
                      ihr bespielte sie konsequent die Rückhandseite von Graf.
                      Aber anders als bei hunderten Spielerinnen vor ihr, gelang
                      es Graf nur selten, die Rückhand zu umlaufen. Zu genau, zu
                      lang waren die Grundlinienschläge von Hingis, zu oft
                      streute sie Stoppbälle oder Netzangriffe ein und variierte
                      ihr Rückhandmantra mit einem Angriffsball auf Grafs
                      Vorhand. Und sobald Graf einen zweiten Aufschlag brauchte,
                      stand Hingis lauernd wie eine Schlange einen Meter im
                      Feld.
                    </p>
                    <p>
                      Um es ganz kurz zu machen: Sie spielte wie ein Routinier,
                      der um die eigenen Stärken weiss – und um die Schwächen
                      der Gegnerin.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-4-paris-1999.jpg'
                          : '../../images/5-4-paris-1999-desktop.jpg')}
                      />
                      <figcaption>
                        Hat noch nie etwas gebracht: Diskussion mit der
                        Schiedsrichterin. Foto: Thomas Coex (Keystone/AFP)
                      </figcaption>
                    </SideElement>
                    <p>
                      Den ersten Satz gewann sie erschreckend leicht. Im zweiten
                      führte sie mit einem Break schnell 2:0. Das Publikum
                      spürte, dass der Deutschen nicht mehr viel einfiel, und
                      begann, sie mit «Steffi, Steffi»-Rufen anzufeuern. Im
                      dritten Spiel gab die Linienrichterin einen Return von
                      Hingis «out», eine Entscheidung, die Hingis anzweifelte,
                      woraufhin die Schiedsrichterin von ihrem Stuhl
                      herunterstieg, um den Abdruck zu überprüfen.
                    </p>
                    <p>
                      Die Schiedsrichterin bestätigte die Entscheidung. Und in
                      diesem Moment, mit achtzehn Jahren, beging Hingis einen
                      Fehler, an den sie bis heute, zweiundzwanzig Jahre später,
                      immer wieder erinnert wird.
                    </p>
                    <p>
                      Statt das Urteil zu akzeptieren – es wäre dann 0:15
                      gestanden, Hingis hätte ihr Game noch immer problemlos
                      gewinnen können –, statt sich also auf den <i>nächsten</i>{' '}
                      Punkt zu konzentrieren, ging sie auf die Seite ihrer
                      Gegnerin – ein absoluter Tabubruch im Tennis –, um den
                      Ballabdruck selbst zu überprüfen. Die Schiedsrichterin
                      aber blieb dabei: Der Ball war draussen. Hingis setzte
                      sich auf ihren Stuhl wie ein trotziges Kind. Erst die
                      Androhung der Disqualifikation brachten sie dazu,
                      weiterzuspielen. Das Publikum war ausser sich, feierte
                      aber nicht nur seine «Steffi», sondern stiess auch wüste
                      Beleidigungen und Buhrufe gegen die Schweizerin aus.
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/07-roland-garros-1999.mp4')}
                        posterImage={require('../../videos/07-roland-garros-1999.jpg')}
                        caption='War der Ball out? Material: Roland-Garros'
                      />
                    </SideElement>
                    <p>Drei Dinge muss man an dieser Stelle festhalten.</p>
                    <p>
                      Erstens: In der verlangsamten Wiederholung sieht man recht
                      deutlich, dass der Ball von Hingis die Linie berührte, und
                      man kann sich zumindest fragen, ob es nicht Steffi Graf
                      war, die ein «Unsportsmanlike Conduct» beging, als sie
                      nicht zugeben wollte, dass der Ball drin war. Sie war
                      zwölf Jahre älter als Hingis, hatte solche Szenen x-fach
                      erlebt. Warum hatte sie nicht die Grösse, die Entscheidung
                      der Schiedsrichterin zu korrigieren? Sie wäre in diesem
                      Moment zurecht zur Königin von Roland-Garros gekürt
                      worden.
                    </p>
                    <p>
                      Zweitens: Das Intermezzo brachte Graf zurück ins Spiel.
                      Hingis gelang zwar beim Stand von 4:4 erneut ein Break mit
                      einer Longline-Rückhand, die für Graf so überraschend kam,
                      dass sie nicht einmal den Versuch unternahm, den Ball zu
                      erreichen. Aber die Deutsche entschied die Partie und den
                      Satz für sich.
                    </p>
                    <p>
                      Und drittens: Hingis war achtzehn. Andere machen in dem
                      Alter die Matura. Das ist sicher auch ein Moment grossen
                      Drucks, aber niemand schaut dabei zu. Niemand buht dich
                      aus, wenn du einen Fehler machst. Niemand hält die Kamera
                      drauf, wenn dir Tränen der Verzweiflung in die Augen
                      schiessen. Hingis war ganz allein, als sie zusammenbrach.
                      Und 16’000 johlende Zuschauer:innen sahen zu. Tennis,
                      lernt man in diesem Augenblick, ist die einsamste aller
                      Sportarten. Im Boxen hat jeder seine Ecke, in der ihm der
                      Trainer fast zärtlich Vaseline ins Gesicht streicht und
                      Mut zuredet. Im Tennis darf die Trainerin von der Tribüne
                      aus höchstens höflich klatschen.
                    </p>
                    <p>
                      Im letzten Satz verlor Hingis dann das Gefühl für den
                      Ball, für die Situation, für sich selbst. Jeder
                      Hobbysportler, jede Hobbyspielerin kennt das: Auf dem
                      Platz wird man auf eine höchst unangenehme Weise an sich
                      selbst erinnert. Man bekommt die schönsten, aber auch
                      schlimmsten Seiten seiner selbst präsentiert.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-5-paris-1999.jpg'
                          : '../../images/5-5-paris-1999.jpg')}
                      />
                      <figcaption>
                        Wünscht man niemandem: Verzweifeln unter den Augen von
                        16'000 Menschen. Foto: Patrick Kovarik (AFP/Getty
                        Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Hingis haderte mit der Schiedsrichterin und dem Publikum,
                      das sie nun feindselig ausbuhte. Sie war so frustriert,
                      dass sie zum letzten Mittel der Gegenwehr griff: Grafs
                      ersten Matchball wehrte sie mit einem unsportlichen
                      Aufschlag von unten ab, was aber weniger Ausdruck von
                      Arroganz war, als ein Einblick in ihre Verzweiflung. Als
                      wolle sie das offensichtliche Ende irgendwie doch noch
                      abwehren, servierte Hingis beim zweiten Matchball wieder
                      von unten und begann direkt im Anschluss eine Diskussion
                      mit der Schiedsrichterin, diesmal wegen der Pfiffe von der
                      Tribüne. Graf stiess dazu und sagte die legendären Worte:
                      «Are we gonna play tennis or are we talking a little bit?
                      We play tennis? Okay.»
                    </p>
                    <p>
                      Hingis verlor das Spiel. Und die Fassung. Unter dem Jubel
                      der Zuschauer:innen ging sie weinend vom Platz, ohne die
                      Ehrung abzuwarten. «Wenn meine Mutter nicht da gewesen
                      wäre, wäre ich nicht zurückgegangen», erzählt sie uns.
                      «Ich dachte, die wollen mich umbringen.»
                    </p>
                    <p>
                      Melanie Molitor sagt: «Ich persönlich wäre auch nicht
                      zurück. Nie würde ich in einer solchen Situation
                      zurückkommen. Aber Martina ist nicht ich. Und ihre
                      Position wäre wahnsinnig geschwächt worden, wenn sie nicht
                      zurückgekommen wäre. Dass ich sie wieder hinausschickte,
                      dass ich mit ihr zurück auf den Platz ging, war eine reine
                      Kopfentscheidung von mir. Das Herz, die Gefühle sagten
                      etwas ganz anderes. Ich habe das alles auch als sehr
                      unfair erlebt.»
                    </p>
                    <p>
                      Nach schier endlosen Minuten erschien Martina Hingis Arm
                      in Arm mit Melanie Molitor wieder auf dem Court. Lange
                      klammerte sie sich an ihre Mutter, bitterlich weinend, bis
                      sie sich schliesslich aufraffte, zur Preisverleihung
                      schritt und Steffi Graf gratulierte. Dann richtete sie
                      sich an das Publikum und sagte auf Französisch: «Ich komme
                      nächstes Jahr wieder, und vielleicht seid ihr ja dann auf
                      meiner Seite.»
                    </p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/09-roland-garros-1999.mp4')}
                        posterImage={require('../../videos/09-roland-garros-1999.jpg')}
                        caption='Die Siegerehrung gewinnt Martina Hingis. Material: Roland-Garros'
                      />
                    </SideElement>
                    <p>
                      Sie sollte nie mehr einen Grand-Slam-Titel im Einzel
                      gewinnen.
                    </p>
                    <p>
                      In all den Jahren, die seit dem Paris-Final 1999 vergangen
                      sind, wurde Hingis immer wieder auf diesen Moment
                      angesprochen, nie war sie in der Lage, ihr Verhalten an
                      diesem Nachmittag vollständig zu erklären.
                    </p>
                    <p>
                      «Man hat lange nicht verstanden, wie ich funktioniere»,
                      sagt sie uns. «Steffi war eine Arbeiterin. Eine Maschine.
                      Ihr sah man die Anstrengung an. Mir nicht. Bei mir sah es
                      so leicht aus. Nach wenig Aufwand.»
                    </p>
                    <p>
                      Und das passte der Schweiz nicht. Erfolg kann man sich
                      nicht erspielen, man muss ihn sich erarbeiten. Wer etwas
                      mit Leichtigkeit schafft, ist suspekt. Möglich, dass sich
                      das mit Roger Federer ein wenig änderte. Seine Eleganz und
                      Schwerelosigkeit auf dem Platz bewundern wir, mehr noch:
                      Wir ahnen, dass auch Mühelosigkeit Kraft kostet, dass auch
                      Leichtigkeit Übung braucht. Und grosse Anstrengung
                      unsichtbar sein kann.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-5-4' id='section-5-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 11</h6>
                    <h5>Einen Kopf kleiner</h5>
                    <p>
                      So bedeutend Martina Hingis für das Frauentennis war, so
                      untypisch war ihr Spiel für die damalige Zeit. Denn
                      parallel zu ihrem Aufstieg begann die Ära des
                      «Power-Baseline-Tennis». So nennt man das bis heute
                      dominierende Grundlinienspiel, das das stakkatoartige
                      Serve-and-Volley der 1980er-Jahre verdrängte. Die
                      Veränderung war massiv, und sie war eng verknüpft mit
                      einer technischen Innovation: dem Aufkommen der
                      Kunststoffschläger.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/5-6-kalifornien-1999.jpg'
                          : '../../images/5-6-kalifornien-1999.jpg')}
                      />
                      <figcaption>
                        1,70 gegen 1,85 Meter: Martina Hingis und Venus Williams
                        im Jahr 1999. Foto: Harry How (Allsport)
                      </figcaption>
                    </p>
                    <p>
                      Vereinfacht gesagt, gibt es im Tennis zwei Schläge:
                      Vorhand und Rückhand. Beide kann man auf zwei
                      unterschiedliche Arten spielen. Topspin bedeutet, dass man
                      den Ball mit einer Aufwärtsbewegung des Schlägers so
                      streift, dass er einen Vorwärtsdrall bekommt. Dadurch wird
                      die Flugbahn gekrümmt, und der Ball fliegt nach dem
                      Aufprall hoch weg. Das drängt die Gegnerin aus dem Feld
                      heraus.
                    </p>
                    <p>
                      Die zweite Schlagvariante ist der Slice. Der Ball wird mit
                      einer Abwärtsbewegung des Schlägers «angeschnitten» und
                      erhält einen Rückwärtsdrall. Beim Slice hat der Ball eine
                      extrem flache und lange Flugbahn, und nach dem Aufprall
                      springt er niedrig ab, was es für die Gegnerin schwierig
                      macht, ihn zurückzuspielen.
                    </p>
                    <p>
                      Topspin und Slice wurde schon immer gespielt, aber mit dem
                      Aufkommen der grösseren Kunststoffschläger wurde der
                      Topspin schneller und gefährlicher. Die Topspin-Ära führte
                      zu einer merkwürdigen Uniformiertheit – alle benutzten
                      plötzlich den gleichen Schlag – und einer grossen äusseren
                      Ähnlichkeit der Spielerinnen.
                    </p>
                    <p>
                      Die Williams-Schwestern standen sinnbildlich für diese
                      neue Spielerinnengeneration, die die Tenniswelt mit
                      raketenhaften Aufschlägen und extrem früh genommenen
                      Returns aus den Angeln hob. Alles an ihnen war
                      einschüchternd: ihre Grösse, ihr Körperbau, ihre Kraft,
                      ihr Defensivspiel. Athletik, Muskelkraft und Ausdauer
                      wurden wichtiger als Ballgefühl, Raffinesse und
                      Ideenreichtum.
                    </p>
                    <p>
                      In gewisser Weise war Hingis die Antithese zu diesem
                      Tennis. Mit ihren 1,70 Metern war sie schlicht zu klein,
                      um körperlich mitzuhalten, weshalb sie früh verstand, dass
                      sie Serena (1,75 Meter) oder Venus Williams (1,85 Meter)
                      nie mit Kraft würde schlagen können, nur mit Spielwitz.
                    </p>
                    <p>
                      Die Schläge der Williams-Schwestern waren Geschosse. Die
                      von Hingis waren im Vergleich von einer grossen
                      Leichtigkeit. Ihnen fehlte die Wucht, sie zerschmetterten
                      die Gegnerinnen nicht, sie drängten sich ihnen eher auf
                      wie ein brillanter Einfall.
                    </p>
                    <p>
                      Im Final des US Open 1997 gelang es Martina Hingis noch,
                      Venus Williams <i>auszuspielen</i>, sie kontrollierte die
                      hochgelobte Debütantin mit frechen Stoppbällen und
                      herausragender Übersicht. Zwei Jahre später, im Herbst
                      1999, verlor sie gegen die Schwester Serena Williams.
                      Diesmal siegte Athletik über Finesse.
                    </p>
                    <p>
                      Am deutlichsten lässt sich dieser Paradigmenwechsel am
                      Aufschlag beobachten. Als eher kleine und leichte
                      Spielerin hatte Hingis keinen harten Aufschlag, die
                      Geschwindigkeit lag typischerweise bei etwa 150 km/h. Ganz
                      anders Serena Williams, die im Schnitt mit 170 km/h
                      aufschlägt, in der Spitze mit über 200 km/h. Der Service
                      von Williams dient nicht der Vorbereitung eines Punktes,
                      er <i>ist</i> der Punkt.
                    </p>
                    <p>
                      Der Aufschlag ist eine der technisch anspruchsvollsten
                      Bewegungen im Sport überhaupt, in seiner Komplexität
                      vergleichbar mit dem Drive beim Golf. Die Idee des
                      Services ist es, die Gegnerin vor maximale Probleme zu
                      stellen. Es geht eben gerade nicht darum, den Ball «zu
                      servieren», also die Gegnerin zu bedienen. Es geht
                      umgekehrt genau darum, wie der Westschweizer Etienne
                      Barilier schrieb, «jemandem einen schlechten Dienst zu
                      erweisen», also den Ball so im gegnerischen Feld zu
                      platzieren, dass er nicht erreicht wird.
                    </p>
                    <p>
                      Der Service im Tennis eröffnet das Spiel und diktiert den
                      weiteren Verlauf des Ballwechsels. Ein für die Gegnerin
                      unerreichbarer Aufschlag resultiert direkt in einem Punkt,
                      ein schwacher oder unplatzierter Aufschlag lädt zum
                      Gegenangriff ein. Entsprechend neurotisch gehen die
                      meisten Spieler:innen mit diesem einleitenden Moment des
                      Spiels um. Ivan Lendl hatte Sägespäne in der Hosentasche,
                      mit denen er den Schlägergriff abrieb, Novak Djokovic
                      tippt den Ball enervierend oft auf, bevor er serviert, und
                      Rafael Nadal … Nadal ist ein Kapitel für sich.
                    </p>
                    <p>
                      Martina Hingis war anders. Sie tippte den Ball zweimal,
                      manchmal dreimal, blickte kurz auf und servierte. Keine
                      überflüssigen Bewegungen, keine Rituale. Kein endloses
                      Rudern mit dem Schläger, kein Scharren mit den Füssen,
                      kein Zupfen am Trikot. Sie servierte einfach den Ball.
                      Fast schien es, als hätte sie es eilig.
                    </p>
                    <p>
                      Als sich Martina Hingis Anfang 2003 zum ersten Mal vom
                      Tennis zurückzog, war sie erst zweiundzwanzig Jahre alt.
                      Sie hatte zunehmend Mühe mit dem Powertennis der
                      Williams-Schwestern, von Lindsay Davenport und der
                      wiedererstarkten Jennifer Capriati, doch vor allem zahlte
                      sie nun Tribut für ihr frühes Debüt auf der Tour. Acht
                      Jahre lang, seit sie vierzehn war, hatte sie auf Topniveau
                      gespielt. Häufig bestritt sie über zwanzig Turniere pro
                      Jahr und musste wegen ihrer körperlichen Unterlegenheit
                      oft kämpfen. Auch schlug sie eher selten Asse, musste also
                      jeden Punkt ausspielen, was eine immense Kraftanstrengung
                      bedeutete. Ihre Spielweise resultierte in chronischen
                      Entzündungen im linken Fuss, Bänderrissen, Operationen.
                    </p>
                    <p>
                      Es waren vor allem die Niederlagen gegen drei Russinnen im
                      Jahr 2002, die sie im Entschluss bestärkten, aufzuhören.
                      «Die waren schon gut, und im Jahr darauf sind sie richtig
                      explodiert», erzählt sie uns. «Aber damals dachte ich:
                      Gegen solche Gegnerinnen darfst du nicht verlieren.»
                    </p>
                    <p>
                      Und da war noch etwas: «Habt ihr den ‹Borg / McEnroe›-Film
                      gesehen? Ich konnte total mit Borg mitfühlen: Entweder
                      hast du die Chance, die ganz grossen Turniere zu gewinnen,
                      oder du lässt es sein. Ich empfand genau gleich: Wenn du
                      mal die Nummer 1 warst, willst du nicht die 2 sein.»
                    </p>
                    <p>
                      Hingis hörte mit zweiundzwanzig Jahren auf, weil sie die
                      Überzeugung verloren hatte, die sie zuvor acht Jahre lang
                      von Sieg zu Sieg getragen hatte: jede Spielerin dieser
                      Welt schlagen zu können. 
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-6' id='section-6'>
                <SegmentHeader
                  part='Vierter Teil'
                  title='Das Genie Hingis'
                  image={require(isMobile
                    ? '../../images/6-usopen.jpg'
                    : '../../images/6-australien-desktop.jpg')}
                  caption={
                    isMobile
                      ? 'Foto: Focus on Sport/Getty Images'
                      : 'Foto: Ullstein Bild/Getty Images'
                  }
                />
              </Element>

              <Element className='section' name='section-6-1' id='section-6-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 12</h6>
                    <h5>«Weil sie das Leben liebt»</h5>
                    <p>
                      Als wir Martina Hingis im Herbst 2019 zum ersten Mal
                      treffen, liegt ihr Rücktritt zwei Jahre zurück (man
                      vergisst das leicht, auch weil es schwer zu glauben ist,
                      aber sie hatte mehrere Comebacks und spielte noch im Alter
                      von siebenunddreissig Jahren auf Weltklasseniveau Tennis).
                      Sie hat eine Tochter zur Welt gebracht, Lia, und lebt mit
                      ihrem Mann Harald Leemann, einem Sportmediziner am Zuger
                      Kantonsspital, in einer Wohnung in Zug mit Blick über den
                      See. Leemann arbeitet viel, aber in die Kita will Hingis
                      ihre Tochter nicht schicken. Wenn sie Tennis spielt oder
                      ihre Pferde ausreitet – beides tut sie mehrmals pro Woche
                      –, schaut Grossmutter Molitor zu Lia.
                    </p>
                    <p>
                      Es war nicht ganz leicht, diesen Termin zu bekommen, und
                      wir denken zu dem Zeitpunkt auch noch nicht daran, die
                      Lebensgeschichte von Martina Hingis aufzuschreiben. Wir
                      möchten einfach ein Interview mit ihr führen. Auf uns
                      macht sie allerdings nicht den Eindruck, dass sie
                      besonders interessiert daran wäre, sich den Medien zu
                      erklären.
                    </p>
                    <p>
                      Mit der Zeit aber begreifen wir, dass das nicht ganz
                      stimmt. Sie hat sehr wohl das Bedürfnis, verstanden zu
                      werden. Nur wurde sie Mal um Mal enttäuscht. Sie will gern
                      über sich reden und hat zugleich genug davon. Sie möchte
                      ihr Leben erzählen, aber scheut sich davor, weil sich die
                      Medien in ihrer Wahrnehmung auf die immergleichen
                      Geschichten beziehen.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-1-monica-seles.jpg'
                          : '../../images/6-1-monica-seles.jpg')}
                      />
                      <figcaption>
                        Beidhändige Urkraft: Monica Seles 1991 am US Open. Foto:
                        Getty Images/Stringer
                      </figcaption>
                    </SideElement>
                    <p>
                      «Es schmerzt, immer nur auf meine Fehler angesprochen zu
                      werden, auf den Paris-Final, die Kokainaffäre,
                      Männergeschichten», sagt sie eineinhalb Jahre nach unserem
                      ersten Treffen, als sie uns im Frühling 2021 überraschend
                      aus dem Auto anruft. Sie ist auf dem Heimweg von einem
                      Fernsehinterview, das nicht in ihrem Sinn verlief, und
                      genervt, dass sie überhaupt zugesagt hatte. «Ich tue es
                      dann doch immer wieder, aber eigentlich bin ich es leid,
                      mich zu rechtfertigen.»
                    </p>
                    <p>
                      In diesem ersten Interview im Herbst 2019 sprechen wir vor
                      allem über ihre Kindheit in der ČSSR. Vieles hören wir zum
                      ersten Mal. Am Ende fragen wir schüchtern, ob wir uns
                      vielleicht noch einmal treffen können, es gäbe ja noch
                      viel zu fragen. Sie zögert ein wenig, dann sagt sie
                      lächelnd: «Es gibt auch noch viel zu erzählen.»
                    </p>
                    <p>
                      Einmal treffen wir sie in der Tennishalle, in der sie mit
                      ihrer Mutter Kinder trainiert. Wir fragen, was in ihren
                      Augen ihr bestes Spiel gewesen sei.
                    </p>
                    <p>
                      «Das war im März 2000 gegen Monica, im Halbfinal auf Key
                      Biscayne. Ein ziemlich perfektes Spiel. Ich gewann 6:0,
                      6:0. Sie war die Nummer 7 der Welt, und ich habe sie …»,
                      sie hält kurz inne, «doch, das kann man so sagen: Ich habe
                      sie demontiert. Ich glaube, das war recht hart für sie.»
                    </p>
                    <p>
                      Die Rede ist von der Amerikanerin Monica Seles, geboren
                      1973 im damaligen Jugoslawien. Als sie 2008 ihren
                      Rücktritt bekannt gab, ging sie als vielleicht
                      meistverehrte Spielerin, die das Tennis je gesehen hat.
                    </p>
                    <p>
                      «Key Biscayne? Ich erinnere mich noch genau», lacht Seles,
                      als wir eines Nachmittags über Zoom mit ihr sprechen.
                      «Martina hat mich völlig auseinandergenommen.» Sie sitzt
                      in ihrem sonnendurchfluteten Wohnzimmer in Sarasota an der
                      Westküste Floridas, wo sie lebt, seit Nick Bollettieri sie
                      1986 für seine Tennis-Akademie entdeckte. «Fragt, was
                      immer ihr wollt!», sagt sie und lächelt. «Wenn es um
                      Martina geht, habe ich alle Zeit der Welt.»
                    </p>
                    <p>
                      Von Monica Seles sagen viele, sie hätte die erfolgreichste
                      Tennisspielerin der Geschichte werden können. Sie war
                      fünfzehn, als sie 1989 auf der Profitour debütierte, und
                      gewann noch vor ihrem zwanzigsten Geburtstag acht
                      Grand-Slam-Turniere. 1991 löste sie Steffi Graf nach 186
                      Wochen als Nummer 1 der Weltrangliste ab.
                    </p>
                    <p>
                      So erinnert sie sich an ihre erste Partie gegen Hingis
                      Ende 1996, als die beiden im Final eines Turniers in
                      Oakland, Kalifornien, aufeinandertrafen: «Martina war ein
                      Kind, aber spielte wie eine Erwachsene. Nie zuvor war ich
                      einer so jungen Spielerin begegnet, die so viel vom Spiel
                      verstand. Das wirklich Besondere aber war ihre
                      Schnelligkeit im Kopf. Die meisten Spielerinnen ziehen
                      ihren Plan durch, machen während einer Partie vielleicht
                      eine oder zwei Anpassungen. Die richtige Analyse erfolgt
                      hinterher. Martina hingegen konnte ich regelrecht dabei
                      zusehen, wie sie nachdachte und ihr Spiel anpasste,{' '}
                      <i>während</i> wir spielten.»
                    </p>
                    <p>
                      Hingis gewann, es war ihr zweiter Turniersieg auf der
                      Profitour. Die Saison beendete sie als Nummer 6 der Welt,
                      mit sechzehn Jahren. Als wir Monica Seles erzählen, dass
                      manche Hingis in der Schweiz lange als arrogant und etwas
                      abgehoben wahrgenommen haben, versteht sie zuerst gar
                      nicht, wovon wir sprechen, so abwegig erscheint ihr das.
                      Dann sagt sie:
                    </p>
                    <p>
                      «Dass sie immer die Gleiche blieb, im Erfolg ebenso wie im
                      Misserfolg, mochte ich an Martina am meisten. Sie war so
                      geerdet, hatte nie eine riesige Entourage um sich wie
                      andere Topspielerinnen. Es waren nur sie, ihre Mutter und
                      Mario. Sie liess nicht einmal Sparringspartnerinnen
                      einfliegen wie viele andere, sie trainierte mit den
                      Spielerinnen, die gerade da waren.»
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-2-monica-seles.jpg'
                          : '../../images/6-2-monica-seles.jpg')}
                      />
                      <figcaption>
                        Wie eine grosse Schwester: Seles mit Hingis im Jahr
                        1989. Foto: Marcel Noecker (RDB/Ullstein Bild/Getty
                        Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Besonders verbunden fühlte sich Seles mit Melanie Molitor,
                      die sie aus Respekt auch heute noch «Miss Molitor» nennt.
                      Molitor erinnerte Seles an ihren Vater Károly, der sie bis
                      zu seinem Tod 1997 trainierte und an jedes Turnier
                      begleitete. «Ich sagte Martina immer: ‹Wenn Du deine
                      Mutter als Trainerin entlässt, bin ich die Erste, die sie
                      einstellt.›»
                    </p>
                    <p>«Warum?», fragen wir.</p>
                    <p>
                      «Weil sich Miss Molitor von den anderen Trainerinnen und
                      Trainern auf der Tour unterschied. Wenn Martina und ich
                      zusammen trainierten, dachte sie nicht: ‹Oh, Monica ist
                      eine Gegnerin meiner Tochter, ich will nicht, dass sie
                      besser wird.› Sie teilte ihr Wissen mit mir, gab mir
                      Feedback und Tipps, als wäre sie nicht Martinas, sondern
                      meine Trainerin. Sie war bescheiden und selbstlos, es ging
                      ihr immer um das Spiel. Dafür bewunderte ich sie sehr. Es
                      gab auf der Tour auch ganz andere Eltern, solche, die mir
                      die schlimmsten Beleidigungen zuriefen, wenn ich gegen
                      ihre Töchter spielte.»
                    </p>
                    <p>
                      In diesem Moment klingelt das Telefon von Monica Seles.
                      Sie geht ran – es ist wohl ihr Ehemann Tom Golisano – und
                      lässt uns warten. Gerade als wir denken, dass sie nicht
                      mehr zurückkehren wird, erscheint sie wieder im Bild. Sie
                      wolle noch einmal etwas über Hingis sagen.
                    </p>
                    <p>
                      «So viele Spielerinnen auf der Tour grüssen dich nicht
                      mal, wenn du an ihnen vorbeigehst. Manche denken
                      vielleicht, sie müssten so sein, um Erfolg zu haben. So
                      war Martina nie. Sie hatte immer Zeit für einen Schwatz
                      oder ein Lachen. Wenn ich ein junges Mädchen trainieren
                      könnte, möchte ich, dass es die Persönlichkeit von Martina
                      hat: Sie war kompetitiv, aber wusste auch, dass es im
                      Tennis nicht um Leben und Tod geht.»
                    </p>
                    <p>
                      Seles macht wieder eine Pause. Wir können nur ahnen, woran
                      sie denkt. Mehr als jede andere weiss sie, dass man das
                      Spiel nicht mit dem Leben verwechseln sollte. Bei einem
                      Turnier in Hamburg 1993 hatte ihr ein psychisch kranker
                      Steffi-Graf-Verehrer ein Messer in den Rücken gestochen.
                      Die Wunde verheilte, aber sie selbst kam nicht mehr zur
                      Ruhe. Tennis wurde zur Nebensache.
                    </p>
                    <p>
                      Wir bitten sie, uns noch mehr über diese Seite von Hingis
                      zu erzählen.
                    </p>
                    <p>
                      «Schaut euch ihre Pferde an, wie sehr sie schon als
                      Mädchen Pferde liebte. Selbst als sie die Nummer 1 der
                      Welt war, ging sie reiten, skifahren, skaten. Jeder
                      normale Trainer hätte ihr das wegen der Verletzungsgefahr
                      verboten.»
                    </p>
                    <p>
                      Seles spielt auf die Geschichte an, als sich Hingis 1997
                      nach einem Sturz vom Pferd einer Kniespiegelung
                      unterziehen musste, die fehlende Fitness kostete ihr
                      vielleicht den Finalsieg gegen Iva Majoli am French Open
                      und damit den Gewinn des Grand-Slams in dem Jahr.
                    </p>
                    <p>
                      «Martina aber zog das durch, weil sie das Leben liebt»,
                      fährt Seles fort, «weil sie auch neben dem Tennis ein
                      Leben haben wollte. Ich glaube, das ist der Grund, warum
                      sie mit allem so gut zurechtkam.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-2' id='section-6-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 13</h6>
                    <h5>Drei Arten des Sehens</h5>
                    <p>
                      0:6, 0:6. Gibt es in irgendeiner anderen Sportart ein
                      eindeutigeres, brutaleres Resultat? Es bedeutet, dass du
                      chancenlos warst, dass du auf eine überlegene Gegnerin
                      gestossen bist, die immer schon ahnte, wohin du den Ball
                      spielen würdest, und dich selbst an den Orten überraschte,
                      wo du dich sicher fühltest.
                    </p>
                    <p>
                      Dass Hingis das 6:0, 6:0 gegen Seles als das beste Spiel
                      ihres Lebens beschreibt, liegt aber nicht daran, dass sie
                      Seles «demontierte». Es liegt daran, dass sie an diesem
                      Tag ihre beiden grossen Stärken in Perfektion vereinte:
                      Das Lesen des gegnerischen Spiels. Und das Gefühl für ihr
                      eigenes.
                    </p>
                    <p>
                      Sie selbst sagt uns: «Seles und Capriati waren fürs Mami
                      halt die Anhaltspunkte. Wir versuchten, ihr Spiel zu
                      imitieren und noch zu verbessern. Ich habe versucht, die
                      Bälle auch so früh zu nehmen. Aber auch, noch
                      variantenreicher zu spielen.»
                    </p>
                    <div style={{ marginTop: '2em' }}>
                      <VideoPlayer
                        mp4={require('../../videos/13-spielstil.mp4')}
                        posterImage={require('../../videos/13-spielstil.jpg')}
                        caption='Lobs, Stoppbälle, Tennisschach: Kleine Einführung in den Hingis-Spielstil. Material: Australian Open TV, Roland-Garros, Eurosport'
                      />
                    </div>
                    <p>
                      Warum, so fragen wir uns während der Recherche einige
                      Male, sind Spitzensportler:innen so wenig erhellend, wenn
                      es darum geht, ihre Leistungen zu beschreiben, wenn sie
                      doch die einzigen Menschen sind, die tatsächlich wissen,
                      wie es sich anfühlt, so wahnsinnig gut zu sein?
                    </p>
                    <p>
                      Es ist – der Gedanke stammt von David Foster Wallace – das
                      uralte Paradox zwischen Kreieren und Betrachten, zwischen
                      «etwas tun» und «darüber reden». Es gibt das eine nicht
                      ohne das andere, und zugleich kommt beides selten
                      zusammen. Vielleicht ist dies auch der Grund dafür, dass
                      Medienkonferenzen oft so verführerisch und zugleich
                      enttäuschend sind: Man erhofft sich einen Einblick in das
                      Denken einer Gottheit, einen O-Ton aus den innersten
                      Kammern der Genialität. Und erfährt doch nur Banales.
                    </p>
                    <p>
                      Die Zuschauerin, die das aussergewöhnliche Talent von
                      Martina Hingis am häufigsten gesehen hat, ist natürlich
                      ihre Mutter. Auch sie hält die Fähigkeit der Tochter, sich
                      anzupassen – also das Spiel der Gegnerin zu lesen und
                      darauf zu reagieren –, für eine ihrer grossen Stärken.
                      Aber sie erzählt es anders.
                    </p>
                    <p>
                      Sie erklärt uns: «Bei Martina gibt es ist nicht einen
                      Ball, den sie nicht kann. Klar, sie trifft nicht jeden
                      Ball und macht nicht jeden Punkt. Aber es gibt keinen
                      Ball, auf den sie nicht theoretisch eine Antwort hätte.
                      Ihre körperliche Unterlegenheit war wiederum ihre grösste
                      Schwäche, wir konnten das nicht ändern, aber wir konnten
                      damit arbeiten.»
                    </p>
                    <p>
                      «Sie musste schneller auf den Beinen sein als andere?»,
                      fragen wir.
                    </p>
                    <p>
                      «Nein!», ruft Molitor aufgebracht, «sie war nicht
                      schneller auf den Beinen. Sie war schneller im Kopf, mit
                      den Augen!»
                    </p>
                    <p>
                      Die Sache mit dem Sehen ist für Molitor zentral. Es geht
                      ihr nicht nur darum, richtig zum Ball zu stehen, sodass
                      man den Ball genau an der richtigen Stelle trifft – auf
                      Taillenhöhe, ein wenig vor dem Körper – und zum richtigen
                      Zeitpunkt. Es geht laut Molitor um eine ganz andere Art
                      des Sehens: «Wenn die Gegnerin den Ball schlug, wusste
                      Martina schon, was mit dem Ball passiert. Bei Agassi war
                      das auch so: Der war nicht schnell, aber der stand immer
                      schon dort, wo der Ball hinkam.»
                    </p>
                    <p>
                      Es sind eigentlich drei Arten des Sehens, von denen
                      Molitor spricht: Man muss – erstens – den Ball, seine
                      Geschwindigkeit und den Aufprallwinkel im Blick haben. Man
                      muss – zweitens – die Gegnerin im Blick haben, ihre
                      Bewegungen lesen, mögliche Schlagwinkel berechnen und am
                      besten schon drei Schritte nach vorne gemacht haben, wenn
                      sie zum Stoppball erst ansetzt. Und man muss – drittens –
                      den Platz im Blick haben, seine Begrenzungen und die
                      freien Räume darin.
                    </p>
                    <p>
                      Wenn man über Roger Federer sagt, er sehe den Ball wie in
                      Zeitlupe, weshalb er mehr Zeit habe als der Gegner, kann
                      man über Hingis sagen, dass sie in ihrer Art zu spielen an
                      die grossen Spielmacher des Fussballs erinnert: Zinédine
                      Zidane, Michel Platini, Thiago Alcántara. Sie überblickten
                      das Feld, <i>bevor</i> sie den Ball erhielten, wussten
                      also schon vor der Ballannahme, wie es weitergeht, und
                      spielten den Ball in freie Räume, die niemand ausser ihnen
                      sah. Sie waren im Kopf immer einen Schritt weiter als der
                      Gegner, eigentlich weiter als das Spiel, was ihre
                      Bewegungen so ruhig und unangestrengt wirken liess.
                    </p>
                    <p>
                      Genau das traf auf Hingis zu: Sie stand immer richtig zum
                      Ball, die Gegnerinnen erwischten sie selten auf dem
                      falschen Fuss, sie schien auf eine merkwürdige Weise zu{' '}
                      <i>wissen</i>, wohin die Bälle kommen und wohin sie sie
                      schlagen muss.
                    </p>
                    <p>Wie lernt man sowas?</p>
                    <p>
                      Melanie Molitor sagt: «Als wir in die Schweiz kamen,
                      konnte sie nur gegen Erwachsene spielen, weil es hier fast
                      keine Kinder im Tennis hatte. Und bei Erwachsenen ist die
                      Sache so: Alle haben einen guten und einen schwächeren
                      Schlag. Ich sagte Martina, dass sie den besten Schlag
                      ihrer Gegnerin eliminieren müsse. Kann die Gegnerin ihre
                      Waffe nicht mehr benutzen, haben Martinas physischen
                      Nachteile keine Bedeutung mehr.»
                    </p>
                    <p>
                      Klingt einfach, aber ist schwierig, wenn auf der anderen
                      Netzseite Serena Williams steht.
                    </p>
                    <p>
                      «Serenas Vorhand war selbstverständlich viel besser als
                      die von Martina», antwortet Molitor. «Deshalb versuchten
                      wir, dass Serena gar nie in die Situation kommt, um eine
                      gute Vorhand zu schlagen.»
                    </p>
                    <p>«Wie macht man das?», fragen wir.</p>
                    <p>
                      An dieser Stelle gibt Melanie Molitor uns einen Grundkurs
                      in Tennis. «Wenn Sie auf der Grundlinie stehen, können Sie
                      einen Tennisball auf fünf verschiedene Arten nehmen»,
                      doziert sie. «Nehmen Sie ihn nach dem Kulminationspunkt,
                      wenn er schon wieder im Fallen ist, müssen Sie zwei
                      Schritte nach hinten machen und können den Ball nur hoch
                      zurückspielen (1). Sie können aber auch stehenbleiben und
                      entweder hoch ausholen (2) oder den Ball als Halbvolley
                      nehmen (3). Oder Sie gehen zwei Schritte nach vorne und
                      nehmen den Ball Topspinvolley (4). Oder Sie gehen ganz
                      nach vorne und spielen ihn Slicevolley (5).»
                    </p>
                    <p>Sie mustert uns streng, bevor sie weiterfährt.</p>
                    <p>
                      «Sie haben also fünf Möglichkeiten, beherrschen aber nicht
                      alle fünf davon. Welche wählen Sie? Sie müssen sich zudem
                      überlegen, wohin sie den Ball spielen, wer auf der anderen
                      Seite steht – Serena Williams! – und wie die Gegnerin den
                      Ball zurückspielen könnte. Dann müssen Sie auch
                      berücksichtigen, in welchem Moment des Spiels Sie sich
                      befinden. Zu Beginn hat Serena vielleicht die Vorhand
                      besser gespielt, jetzt ist sie müde, aber die Vorhand ist
                      ihr bester Schlag … Fragen über Fragen. All das müssen sie
                      in Sekundenbruchteilen überlegen und entscheiden.»
                    </p>
                    <p>
                      Es sind Fragen, die sich jede Hobbyspielerin, jeder
                      Hobbyspieler stellt. Das Besondere an Martina Hingis? Sie
                      war schneller darin als jede andere auf der Tour, diese
                      Fragen zu beantworten.
                    </p>
                    <p>
                      Ihre zweite Stärke war laut ihrer Mutter die Mentalität.
                    </p>
                    <p>
                      «Martina war eine ganz andere Spielerin als ich. Ich bin
                      ‹schaffe, schaffe›. Martina hat <i>gespielt</i>. Für sie
                      war es kein Problem, sich von den fünf Möglichkeiten für
                      den Halbvolley zu entscheiden. Ich hätte nie den
                      Halbvolley gespielt, aber meine Aufgabe als Trainerin war
                      es nicht, sie mir anzugleichen. Ich wollte sie noch mehr
                      zu dem machen, wie sie selbst war.»
                    </p>
                    <p>
                      Es ist schwer, dieses Eigenschaft zu beschreiben, diesen
                      Sinn für das Unerwartete. Sicher ist, dass Hingis mehr
                      davon hatte als alle anderen.
                    </p>
                    <p>
                      Doch es reicht nicht, einfallsreich zu sein, es bedarf
                      paradoxerweise einer grossen Ernsthaftigkeit, um Ideen zu
                      entwickeln, und Mut, um an sie zu glauben – im Wissen,
                      dass sie misslingen können. Denn das ist der Preis des
                      genialen Schlags: ein missratener Stoppball ist eine
                      Einladung für die Gegnerin zum Netzangriff, ein ungenauer
                      Lob der sichere Punktverlust.
                    </p>
                    <p>
                      Und so ist das Spiel tatsächlich ein Spiegel des Lebens:
                      Wer Neues ausprobiert, macht sich angreifbar. Wer
                      fantasievoll ist, entblösst sich. Wer wagt, gewinnt – aber
                      wird auch scheitern.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-3' id='section-6-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 14</h6>
                    <h5>Bei der Mutter am Esstisch</h5>
                    <p>
                      Lange war die Karriere von Martina Hingis ein
                      Mutter-Tochter-Projekt, zu dem nur wenige Personen Zugang
                      hatten. «Ich machte alles», sagt Melanie Molitor. «Ich
                      leitete das Training, wusch die Kleider, bespannte den
                      Schläger sogar noch dann, als wir schon auf der Profitour
                      waren. Ich konnte mir einfach nicht vorstellen, das an
                      jemanden abzutreten. Ich traute niemandem.»
                    </p>
                    <p>
                      Molitor und Hingis käme es nie in den Sinn, sich als
                      Feministinnen zu bezeichnen, dabei waren sie genau das:
                      Zwei Frauen, die sich ihren Platz erkämpften in einer
                      Welt, die nicht auf sie gewartet hatte.
                    </p>
                    <p>
                      Die Teamkonstellation änderte sich Mitte der 1990er-Jahre,
                      als sich Molitor und Mario Widmer ineinander verliebten.
                      Widmer, geboren 1940, war eine der prägenden Figuren des
                      Schweizer Sportjournalismus, ein Haudegen mit pointierter
                      Schreibe. Damals arbeitete er als «Blick»-Korrespondent in
                      den USA, danach war er kurz Sportchef der Zeitung. Doch
                      1997 kündigte er, zog zu Mutter und Tochter nach
                      Regensdorf und übernahm das Management von Hingis.
                    </p>
                    <p>
                      Wir lernen Mario Widmer kennen, als Molitor und er uns an
                      einem Morgen im Frühling 2021 in Schindellegi empfangen.
                      Sie begrüssen uns höflich, aber kaum haben wir uns an
                      ihren Esstisch gesetzt, machen sie uns klar, dass sie uns
                      nicht trauen. Sie kennen unsere Namen von den
                      «Magglingen-Protokollen», die wir ein halbes Jahr zuvor{' '}
                      <Link allowWordWrap href='170525604713'>
                        im «Magazin»
                      </Link>{' '}
                      veröffentlicht haben, und halten uns für Sporthasser. Sie
                      können sich schlicht nicht vorstellen, dass wir Hingis in
                      unserem Text fair beurteilen werden.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-3-mario-widmer.jpg'
                          : '../../images/6-3-mario-widmer.jpg')}
                      />
                      <figcaption>
                        Seit 1997 ein Team: Martina Hingis, Mario Widmer,
                        Melanie Molitor. Foto: Illustré/RDB/Ullstein Bild/Getty
                        Images
                      </figcaption>
                    </SideElement>
                    <p>
                      Zwei Stunden verbringen wir damit, uns zu erklären.
                      Mehrmals befürchten wir, der Gesprächsabbruch stehe kurz
                      bevor, was uns nervös macht, denn ein Hingis-Porträt ohne
                      die Stimme ihrer Mutter wäre kein Hingis-Porträt.
                    </p>
                    <p>
                      Nicht besonders hilfreich in diesem Moment ist die
                      Tatsache, dass auch Martina Hingis nervös war vor unserem
                      Treffen mit ihrer Mutter. Aber warum? Dazu müssen wir ein
                      wenig ausholen.
                    </p>
                    <p>
                      Anfangs zierte Martina Hingis sich, ihre Mutter überhaupt
                      zu fragen, ob wir sie sprechen könnten. Und als der Termin
                      endlich stand, wollte sie partout nicht dabei sein. Was
                      für eine Beziehung haben die beiden eigentlich?
                    </p>
                    <p>
                      Als wir Hingis einmal in ihrem Appartement in Zug
                      besuchen, ist sie gerade am Packen.
                    </p>
                    <p>
                      «Sie verreisen?», fragen wir. (Es ist mitten in der
                      dritten Corona-Welle.)
                    </p>
                    <p>
                      «Nein», sagt sie. «Harry ist an einer Weiterbildung, da
                      fahre ich mit der Lia nach Hause.»
                    </p>
                    <p>Zu Hause, das ist bei der Mutter in Schindellegi.</p>
                    <p>
                      Vermutlich ist das die unschweizerischste Seite von
                      Hingis: Sie stellt die Familie über alles, findet ein
                      enges Zusammenleben nicht nervig, sondern schön.
                    </p>
                    <p>
                      «Man ist im Osten viel näher miteinander», sagt sie uns.
                      «Warum schicken die Schweizer ihre Eltern ins Altersheim?
                      Damit sie alleine in ihren Vierzimmerwohnungen sitzen
                      können, während die Alten alleine sterben. Warum lässt man
                      das zu?»
                    </p>
                    <p>
                      Wir fragen, warum sie so nervös sei, dass wir ihre Mutter
                      treffen.
                    </p>
                    <p>
                      Sie sagt: «Entweder man versteht sie, oder man versteht
                      sie nicht. Entweder man kommt mit ihr aus, oder man kommt
                      nicht mit ihr aus. Und ich mache mir ein bisschen Sorgen,
                      wie sie euch finden wird.»
                    </p>
                    <p>
                      An all das denken wir, während die Mutter uns mit
                      gekreuzten Armen und durchgedrücktem Rücken skeptisch
                      beäugt.
                    </p>
                    <p>
                      Doch dann, mitten in eine eisige Gesprächspause hinein,
                      sagt sie plötzlich: «Also, was möchten Sie wissen?»
                    </p>
                    <p>
                      Was folgt, ist eines der interessantesten und offensten
                      Interviews, das wir je geführt haben. Als wir uns von ihr
                      und Mario Widmer verabschieden, ist es später Nachmittag.
                    </p>
                    <p>
                      (Zum besseren Verständnis: Alle Zitate von Melanie Molitor
                      in diesem Text stammen aus diesem Gespräch – auch die in
                      den vorangegangenen Kapiteln.)
                    </p>
                    <p>
                      Melanie Molitor und Mario Widmer, das wird im Lauf der
                      Stunden deutlich, ging es nicht um sich selbst. In den
                      Jahren in der Öffentlichkeit machten sie natürlich Fehler,
                      sie wären die Letzten, die das nicht einsehen würden. Doch
                      bei allem, was sie taten, verfolgten sie, wie viele
                      Eltern, zwei anspruchsvolle und manchmal widersprüchliche
                      Ziele. Sie wollten Martina Hingis schützen, aber sie
                      wollten sie auch selbst bestimmen lassen.
                    </p>
                    <p>
                      Molitor: «Ich war der Meinung, dass sie im Alltag
                      möglichst viel Verantwortung übernehmen muss, damit sie
                      auch auf dem Tennisplatz kluge Entscheidungen treffen
                      kann, unter Druck und vor Publikum. Dann geschah es halt
                      ein paar Mal, dass sie in der Öffentlichkeit Dinge sagte,
                      die sie besser nicht gesagt hätte.»
                    </p>
                    <p>
                      Wir erinnern uns daran, wie Melanie Molitor ihren Vater,
                      Martinas Grossvater, beschrieb: als autonom, gradlinig,
                      freiheitsliebend. Als jemanden, der sich nicht
                      unterkriegen, nicht einordnen lassen wollte. Wir möchten
                      die Küchenpsychologie nicht überstrapazieren, aber war
                      nicht genau dies das Wesen von Martina Hingis’ Spiel:
                      freiheitsliebend, schwer einzuordnen, autonom?
                    </p>
                    <p>
                      Als Mario Widmer zu Molitor und Hingis stiess, kannte er
                      sich im Fussball aus – manche sagen, er habe
                      Nationaltrainern die Aufstellung diktieren können –, auch
                      im Boxen fühlte er sich heimisch. Mit Muhammad Ali war er
                      befreundet. Doch die Welt des Tennis war ihm fremd. Er
                      staunte über die schlechte Stimmung in den
                      Frühstücksräumen der Spielerinnenhotels und welchem Stress
                      die Topspielerinnen ausgesetzt waren, wenn sie Woche für
                      Woche irgendwo auf der Welt ein neues Turnier bestreiten
                      und zugleich Medientermine, Sponsorentermine, Fantermine
                      wahrnehmen mussten, während einer zermürbenden
                      elfmonatigen Saison.
                    </p>
                    <p>
                      2021 machte der Tennissuperstar Naomi Ōsaka öffentlich,
                      wie belastend es für sie ist, jeden Turniertag mit einer
                      Pressekonferenz abschliessen zu müssen, und versagte sich
                      zuerst den Medien, dann mehreren Turnieren. Sie erntete
                      Spott, aber auch Bewunderung. Sportler:innen dankten ihr
                      für den Mut, über Depression, öffentlichen Druck und
                      ungesundes Leistungsdenken nicht erst dann zu sprechen,
                      wenn die Karriere vorbei ist.
                    </p>
                    <p>
                      Die späten 1990er-Jahre waren eine andere Zeit.
                      Sportpsychologische Betreuung war selten, mentale
                      Gesundheit kein Thema. Und noch viel mehr als heute
                      dachten die Leute: Wer so viel verdient, kann ein paar
                      Anfeindungen aushalten.
                    </p>
                    <p>
                      Mario Widmer fing an zu verstehen, weshalb es Melanie
                      Molitor so wichtig war, eine Mauer um ihre Familie zu
                      bauen. Neben dem Training musste nicht auch noch der
                      Alltag hart sein.
                    </p>
                    <p>
                      Sie nannten es ihre kleine Insel. Wenn sie für die
                      Vorbereitung der Turniere in den USA ein paar Wochen in
                      Tampa, Florida, verbrachten, wo sie ein Haus besassen, sah
                      ihr Tagesablauf so aus: Am Vormittag trainierten Mutter
                      und Tochter, Mario Widmer kaufte ein und kochte. Dann
                      machte Molitor den Abwasch, Hingis legte sich hin, und
                      Widmer ging golfen.
                    </p>
                    <p>
                      «Das ist etwas Postkommunistisches», erklärt uns Molitor
                      mit einem Schmunzeln. «Sehen Sie, in der Schweiz ist oft
                      wichtig, was draussen ist, was andere von dir denken. Bei
                      uns in der Tschechoslowakei war es immer wichtig, was
                      drinnen ist, was wir voneinander halten.»
                    </p>
                    <p>
                      In Trübbach, als Widmer noch nicht Teil des Teams war, und
                      später in Regensdorf sassen manchmal zehn, fünfzehn Leute
                      am Esstisch, Spielerinnen, Trainer:innen, Eltern. «Wir
                      hatten häufig Gesellschaft», sagt Molitor, «ich wollte,
                      dass Martina gute Menschen um sich hat.» Jennifer
                      Capriati, Monica Seles, Anna Kurnikowa – sie alle waren
                      über die Jahre zum gemeinsamen Training in der Schweiz zu
                      Besuch. 
                    </p>
                    <p>
                      Jetzt, in Schindellegi, sagt Melanie Molitor: «Als wir neu
                      auf der Tour waren, waren die guten Spielerinnen nicht so
                      nett zu Martina. Ich sagte ihr: ‹Wenn du einmal gut bist,
                      darfst du dich nicht so benehmen.› Als Martina die Nummer
                      1 wurde, veränderte sich die Stimmung unter den Besten,
                      wurde irgendwie lockerer.» Sie erzählt es mit einer Wärme
                      in der Stimme, als sei ihr das wichtiger als all die
                      Titel.
                    </p>
                    <p>
                      Molitor coachte nicht nur ihre Tochter auf Platz 1,
                      sondern danach auch Belinda Bencic in die Top Ten. Heute
                      betreut sie die Deutsche Julia Stusek, die gerade
                      Juniorinnen-Europameisterin wurde. Das Bild, das die
                      Schweizer Öffentlichkeit von der Trainerin Melanie Molitor
                      hat, steht im diametralen Verhältnis zu dem Ruf, den sie
                      in der Szene geniesst: Melanie Molitor ist keine
                      verbissene Tennis-Mami, sie ist eine der besten
                      Trainerinnen der Welt.
                    </p>
                    <p>
                      Wie entsteht ein Bild von einem Menschen? Klar ist, dass
                      es nicht aus dem Nichts kommt. Molitors herbe tschechische
                      Art wirkt in der Tat etwas schroff im Vergleich zur
                      bemühten helvetischen Freundlichkeit. Und sie ist ja auch
                      wirklich ein eher skeptischer Mensch, eine strenge
                      Trainerin, war eine Mutter, die von ihrer Tochter viel
                      verlangte. Aber verlangte sie mehr als Pauli Gut von
                      seiner Tochter Lara, Fritz Weyermann von Anita oder Markus
                      Neff von Jolanda?
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-4-mutter.jpg'
                          : '../../images/6-4-mutter.jpg')}
                      />
                      <figcaption>
                        «Ich war der Meinung, dass sie möglichst viel
                        Verantwortung übernehmen muss»: Die Mutter über die
                        Tochter. Foto: Jürgen Hasenkopf
                      </figcaption>
                    </SideElement>
                    <p>
                      Woher also kommt diese Abneigung gegen die Mutter?
                      Vielleicht liegt es genau daran: Dass sie die Mutter ist
                      und nicht der Vater.
                    </p>
                    <p>
                      Das Mutterbild, das Molitor verkörperte, steht im krassen
                      Kontrast zum Schweizer Ideal der aufopferungsvollen,
                      fürsorglichen und warmherzigen, aber letztlich
                      zurückgenommenen Mutter, die ihr Leben lang auf den
                      Bereich des Privaten begrenzt bleibt, wichtig für die
                      Familie, aber als Individuum bedeutungslos. Dem Vater
                      gesteht man zu, dass er Ambitionen hat, für sich ebenso
                      wie für andere. Der Vater wendet sich der weiten Welt zu,
                      hat eine eigene Identität und Vorstellung.
                    </p>
                    <p>
                      In dieser Lesart stellt Melanie Molitor die ungehörige
                      Frau dar, die ihre Männer verliess, um sich durch ihre
                      Tochter zu verwirklichen, statt die ihr zugedachte Rolle
                      einzunehmen. Unter Frauen könnte bei der Ablehnung
                      Molitors auch ein gewisser Frust mitgespielt haben, weil
                      sie ihr Leben mit einer Konsequenz in die eigenen Hände
                      nahm, wie es sich damals nur wenige Schweizerinnen
                      trauten.
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-6-4' id='section-6-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 15</h6>
                    <h5>
                      Als das Frauentennis das Männertennis in den Schatten
                      stellte
                    </h5>
                    <p>
                      Zwischen 1999 und 2001 geschah etwas Einzigartiges: Das
                      Frauentennis löste das Männertennis als grösstes Spektakel
                      ab. «Jetzt gerade», sagte Monica Seles kurz vor dem US
                      Open 2001, «sind die Männer richtig langweilig.»
                    </p>
                    <p>
                      Bei den Männern standen Marat Safin, Gustavo Kuerten,
                      Lleyton Hewitt an der Spitze. Alles gute Spieler, aber sie
                      verblassten im Vergleich zu Anna Kurnikowa, Lindsay
                      Davenport, Monica Seles, den Williams-Schwestern, Martina
                      Hingis, Jennifer Capriati. Und ständig rückten junge
                      Spielerinnen nach, Kim Clijsters etwa oder Justine Henin.
                      Nie zuvor waren so viele talentierte, ehrgeizige,
                      schillernde, aber auch aufmüpfige und unangepasste Frauen
                      in den Top Ten gewesen. Das «New York Magazine» nannte die
                      Rivalinnen, die sich harte Duelle lieferten, dann aber
                      auch immer wieder gemeinsam feierten, «Riot Girls».
                    </p>
                    <p>
                      Es war auch die Zeit, als die WTA versuchte, aus ihren
                      Spielerinnen mehr zu machen als bloss – Spielerinnen. Es
                      gab Empfänge, Galaabende, die Spielerinnen sollten nicht
                      nur spielen, sie sollten gut aussehen, sexy sein, Kluges
                      oder besser noch Provokantes sagen, sich Zeit für
                      Fotoshootings, Sponsorentermine und andere öffentliche
                      Termine nehmen.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-5-spielerinnen.jpg'
                          : '../../images/6-5-spielerinnen.jpg')}
                      />
                      <figcaption>
                        Ein Teil der «Riot Girls» (von links): Venus Williams,
                        Patty Schnyder, Jana Novotná, Martina Hingis, Lindsay
                        Davenport, Nathalie Tauziat, Arantxa Sánchez Vicario,
                        Natallja Swerawa. Foto: Jürgen Hasenkopf (Imago)
                      </figcaption>
                    </p>
                    <p>
                      Tennis wurde dadurch immer lukrativer – die Preisgeldbörse
                      nahm am US Open von 1990 bis 2000 von 6.4 Millionen auf 15
                      Millionen US-Dollar zu. Damit stiegen auch die
                      Erwartungen, die Aufmerksamkeit, der Druck. Und die
                      Topspielerinnen, auf die alle schauten, befeuerten die
                      Konkurrenz, indem sie an Medienkonferenzen gegeneinander
                      stichelten, während Journalist:innen die Zwists genüsslich
                      ausbreiteten. Plötzlich benahmen sich nicht nur John
                      McEnroe oder Jimmy Connors wie Unsympathen und trugen ihre
                      exaltierten Fehden auch jenseits des Tenniscourts aus, nun
                      liefen die Frauen den Männern auch in diesem Punkt den
                      Rang ab.
                    </p>
                    <p>
                      In diesem Umfeld geschah es, dass sich Hingis zu Aussagen
                      hinreissen liess, über die sie heute den Kopf schüttelt
                      und am liebsten gar nicht mehr spricht. Zum Beispiel die
                      Aussage, dass die lesbische französische Spielerin Amélie
                      Mauresmo «ein halber Mann» sei. Oder dass die
                      Williams-Schwestern einen Vorteil in der Vermarktung
                      hätten, weil sie schwarz sind.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/6-6-anna-kournikova.jpg'
                          : '../../images/6-6-anna-kournikova.jpg')}
                      />
                      <figcaption>
                        Konkurrentin, Doppelpartnerin, Freundin: die russische
                        Tennisdiva Anna Kurnikowa. Foto: Greg Wood (AFP/Getty
                        Images)
                      </figcaption>
                    </SideElement>
                    <p>
                      Legendär ist ihre Auseinandersetzung mit der russischen
                      Tennisdiva Anna Kurnikowa im Jahr 2000 in Santiago de
                      Chile. Wenige Wochen zuvor hatten die beiden den
                      WTA-Saisonfinal im Doppel gewonnen, nun spielten sie an
                      einem unbedeutenden Showturnier gegeneinander. Nach einer
                      irrelevanten Linienentscheidung gerieten sie aneinander,
                      und während des anschliessenden Seitenwechsels soll Hingis
                      Kurnikowa angezischt haben: «Du denkst wohl, du bist die
                      Königin? ICH BIN DIE KÖNIGIN!»
                    </p>
                    <p>
                      In der Garderobe sollen Trophäen und Vasen geflogen sein.
                      Hingis tauschte daraufhin Kurnikowa gegen Seles als
                      Doppelpartnerin. Doch ein Jahr später, am US Open, traten
                      die beiden bereits wieder zusammen im Doppel an.
                    </p>
                    <p>
                      Es war eben doch nur ein Spiel. Die Frauen konnten –
                      anders als viele Männer – über die Fehden lachen. Hingis
                      selbst beschreibt die Zeit in der Rückschau als «cool».
                    </p>
                    <p>
                      Einige Monate später, als wir Hingis erneut treffen und
                      sie uns allmählich wie alte Bekannte behandelt, verrät sie
                      uns, was sie in ihrer Karriere über Männer gelernt hat.
                      Von den vielen bemerkenswerten Dingen, die sie uns
                      erzählte, ist das etwas vom Bemerkenswertesten.
                    </p>
                  </div>
                </div>
              </Element>
            </div>

            <div className='ui vertical segment' style={{ padding: '0' }}>
              <Element className='section' name='section-7' id='section-7'>
                <SegmentHeader
                  part='Fünfter Teil'
                  title='Das Leichte und das Schwere'
                  image={require(isMobile
                    ? '../../images/7-martina.jpg'
                    : '../../images/7-martina-desktop.jpg')}
                  caption='Foto: Cyrill Matter'
                />
              </Element>

              <Element className='section' name='section-7-1' id='section-7-1'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 16</h6>
                    <h5>Beziehungsgeschichten</h5>
                    <p>
                      Martina Hingis wurde auf der Tour erwachsen. Was andere in
                      Skilagern oder auf Schulreisen erleben, fand bei ihr in
                      aller Öffentlichkeit statt. Jeder Flirt, jeder Kuss, jede
                      Beziehung wurde von der Boulevardpresse genüsslich
                      begleitet. Zweimal war sie verlobt, einmal schon
                      verheiratet. Sie war mit Tennisspielern, Profigolfern,
                      Fussballstars zusammen.
                    </p>
                    <p>
                      «Man lernt als Sportlerin halt fast nur Sportler kennen»,
                      sagt sie uns achselzuckend. «Viele sind Tennisfans, die
                      kommen an die Grand-Slams, haben einen Badge und hängen da
                      rum. Aber es ist schwierig. Das eine Problem ist der
                      Kalender. Man stellt fest, dass ja jeder seinen Kalender
                      hat, und plötzlich ist ein halbes Jahr rum, und die
                      Gefühle sind am Ausklingen.»
                    </p>
                    <p>
                      Dann erzählt Hingis ebenso offen über Problem Nummer zwei:
                      «Um im Sport erfolgreich zu sein, braucht man ein ziemlich
                      grosses Ego. Weil man die ganze Zeit vor allem auf sich
                      selbst konzentriert sein muss, kann man aber nicht so gut
                      Kompromisse eingehen. Treffen dann zwei Egos aufeinander,
                      ist es zuerst einmal interessant. Man tickt ähnlich, man
                      denkt: Der versteht mich. Doch dann merkt man, dass
                      zwischen zwei Menschen ja gar nichts entstehen kann, weil
                      beide nur auf sich schauen.»
                    </p>
                    <SideElement side='left'>
                      <div className='quote-element'>
                        <p className='quote'>
                          «Männer wollen nicht ‹der Freund von der{' '}
                          <nobr>Hingis</nobr>› sein. Sie wollen, dass es
                          umgekehrt ist. Erst wenn sie älter sind, lernen sie,
                          über der Sache zu stehen.»
                          <div className='person'>Martina Hingis</div>
                        </p>
                      </div>
                    </SideElement>
                    <p>
                      Eine besondere Schwierigkeit, von der sie uns berichtet,
                      kennen vermutlich auch erfolgreiche Frauen ausserhalb des
                      Sports: «Sergio (der Profigolfer Sergio García, mit dem
                      Hingis bis 2002 liiert war) und ich, wir wurden immer
                      miteinander verglichen. Und ich war, das klingt jetzt
                      blöd, schon weiter als er. Am Anfang hat ihn das
                      fasziniert, aber mit der Zeit störte es ihn, dass seine
                      Freundin eine Nummer grösser ist als er.»
                    </p>
                    <p>«War das oft so?», fragen wir.</p>
                    <p>«Ja, leider.»</p>
                    <p>«Sie waren immer die grössere Nummer.»</p>
                    <p>
                      «Ja, und darunter haben die Egos der Männer gelitten.
                      Männer wollen nicht ‹der Freund von der Hingis› sein. Sie
                      wollen, dass es umgekehrt ist. Erst wenn sie älter sind,
                      lernen sie, über der Sache zu stehen.»
                    </p>
                    <p>
                      2016 lernte Martina Hingis den Zuger Sportarzt Harald
                      Leemann kennen, mit dem sie heute noch zusammen ist. «Das
                      war ganz anders. Er kann sich für mich freuen, wenn es mir
                      gut geht. Es gibt keine Konkurrenz zwischen uns.» Sie
                      trinkt einen Schluck Mineralwasser. «Vermutlich weil jeder
                      sein eigenes Metier hat. Ich glaube, das ist wichtig in
                      der Liebe.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-2' id='section-7-2'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 17</h6>
                    <h5>Die schönste Zeit</h5>
                    <p>
                      Wenn man Martina Hingis fragt, wann sie in ihrer Karriere
                      am glücklichsten war, sagt sie nicht: Ihr erster
                      Turniersieg als Profi, die Grand-Slam-Erfolge, der Sprung
                      als jüngste Spielerin auf Platz 1 der Weltrangliste. Sie
                      sagt: Am schönsten war es im Doppel.
                    </p>
                    <p>
                      Die Partien mit zwei Spieler:innen auf jeder Seite des
                      Netzes werden selten im Fernsehen gezeigt, die Preisgelder
                      sind niedrig, reine Doppelspieler:innen erreichen nur in
                      Ausnahmefällen Bekanntheit. Was schade ist. Denn Doppel,
                      besonders Frauendoppel, ist eine unterschätzte Disziplin:
                      schnell, unterhaltsam und weniger als das Einzel abhängig
                      von roher Kraft. Hier gewinnt, wer Technik mit Taktik und
                      Spielwitz verbinden kann. In anderen Worten: Es ist die
                      perfekte Disziplin für Martina Hingis.
                    </p>
                    <p>
                      Hingis kam in einer Zeit auf die Tour, als die besten
                      Einzelspielerinnen meist auch im Doppel antraten. Martina
                      Navrátilová, Jana Novotná, Arantxa Sánchez Vicario,
                      Lindsay Davenport – sie alle waren nicht nur im Einzel
                      Weltklasse, sie waren auch die Nummer 1 der
                      Doppelweltrangliste.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-1-olympia.jpg'
                          : '../../images/7-1-olympia.jpg')}
                      />
                      <figcaption>
                        Spätes Glück: Olympiasilber im Doppel mit Timea
                        Bacsinszky 2016 in Rio de Janeiro. Foto: Claude Diderich
                        (Freshfocus)
                      </figcaption>
                    </SideElement>
                    <p>
                      Auch Hingis zählte dazu. Über die Zeitspanne von zwei
                      Jahrzehnten – zwischen 1998 und 2018 – belegte sie 91
                      Wochen lang Platz 1, das sind fast zwei Jahre. Sie gewann
                      als Doppelspielerin dreizehn Grand-Slam-Titel und sieben
                      weitere im noch weniger populären Mixed-Doppel, Mann und
                      Frau.
                    </p>
                    <p>
                      Doch um Popularität ging es ihr nicht. Um Siege schon –
                      darum ging es ihr immer –, aber da war noch etwas anderes.
                      Es ist eines der grossen Themen ihrer Karriere. Sie selbst
                      findet keine Worte dafür, auch wenn sie mit uns oft
                      darüber redet. Martina Hingis, das verstehen wir mit der
                      Zeit, spielte Doppel, damit sie auf der Tour nicht nur
                      Gegnerinnen hatte, sondern auch mal Partnerinnen –
                      womöglich sogar Freundinnen –, mit denen sie reisen,
                      trainieren, ein gemeinsames Ziel anstreben konnte.
                    </p>
                    <p>
                      In Schindellegi sagt uns Mario Widmer, dass wir uns wohl
                      nicht vorstellen könnten, wie einsam das Leben als
                      Tennisprofi sei. Die Spielerinnen sind jede Woche an einem
                      anderen Ort und zugleich in der immergleichen Blase. Die
                      Tage ähneln sich, man lebt von Spiel zu Spiel, legt sich
                      früh schlafen, sucht das Glück auf dem Court. Und so gibt
                      es auch keinen Platz für das, was am Ende eines Lebens am
                      meisten zählt: Freundschaften. Auch Monica Seles sagt,
                      dass sich die Freundschaft zu Hingis erst nach der
                      Karriere entwickeln konnte.
                    </p>
                    <p>
                      Es ist fast nicht zu glauben, aber ihre 64 Turniersiege im
                      Doppel erreichte Martina Hingis mit siebzehn verschiedenen
                      Spielerinnen. Es gab immer wieder Stimmen, die ihr die
                      vielen Wechsel als Launenhaftigkeit auslegten, besonders
                      als sie sich 1998 von Jana Novotná mit der rüden
                      Begründung lossagte, die Tschechin sei «alt und langsam»
                      geworden. Darin, dass sie mit so vielen Spielerinnen
                      Erfolg hatte, kann man aber auch zwei ganz andere Dinge
                      erkennen.
                    </p>
                    <p>
                      Erstens war sie einfach wahnsinnig lange auf der Tour, so
                      lange wie fast niemand sonst. Nach dem Debüt 1994 und dem
                      ersten Rücktritt 2003 kehrte sie 2006 zurück, gewann im
                      Einzel drei weitere Turniere und stiess noch einmal auf
                      Rang 6 der Weltrangliste vor. 2007 gab sie zum zweiten Mal
                      das Karrierenende bekannt. 2013 kam sie wieder,
                      verzichtete auf Einsätze im Einzel, aber hatte im Doppel
                      die beste Zeit ihres Tennislebens.
                    </p>
                    <p>
                      Dass sie mit so vielen Spielerinnen ein gut
                      funktionierendes Team bildete, zeigt zweitens, dass sie
                      über die unter Einzelsportlerinnen seltene Fähigkeit
                      verfügte, nicht nur sich, sondern auch Mitspielerinnen
                      besser zu machen.
                    </p>
                    <p>
                      Das erfahren wir, als wir uns mit der Deutschen Sabine
                      Lisicki unterhalten, Wimbledon-Finalistin 2011 – und
                      vielleicht der grösste lebende Hingis-Fan. Lisickis
                      Werdegang hat einige Parallelen mit dem von Hingis: Sie
                      wird vom Vater trainiert, einem polnischen Einwanderer. In
                      ihren Anfängen war das Familiengeld so knapp, dass sie
                      sich Turnierteilnahmen im Ausland nur gelegentlich leisten
                      konnte. Und auch sie stiess in ihrer Heimat Deutschland
                      auf viel Unverständnis, weil sie und ihr Vater nicht die
                      waren, «die vor jede Kamera sprangen», wie sie erzählt.
                    </p>
                    <p>
                      Nach einem Jahr der Niederlagen und Verletzungen fragte
                      sie 2013 Hingis, ob sie ihr helfen würde. Der Grund, warum
                      sie sich am tiefsten Punkt ihrer Karriere ausgerechnet an
                      die Schweizerin wandte, hat wiederum mit Melanie Molitor
                      zu tun.
                    </p>
                    <p>
                      Lisicki war zehn, als sie 1999 von einer
                      Sportvermarktungsagentur zu Melanie Molitor geschickt
                      wurde, um von ihr beurteilt zu werden.
                    </p>
                    <p>
                      Am Telefon aus Bradenton, Florida, wo sie zeitweise lebt,
                      erzählt sie uns: «Wir waren damals drei, vier Tage da. Und
                      für mich war das ein riesengrosses Erlebnis, bei ihr im
                      Haus zu schlafen. Weil Martina weg war, durfte ich sogar
                      ihr Zimmer haben. Wir hatten damals kein Geld, ich hatte
                      noch keine Sponsoren, ein Match-T-Shirt kostet 70 Euro!
                      Irgendwann hat mir Melanie Molitor einfach eine Tasche mit
                      Kleidern von Martina gegeben. Ich hatte noch nie in meinem
                      Leben so viele Anziehsachen!»
                    </p>
                    <p>
                      Melanie Molitor sah nicht nur Lisickis Talent, sie sah
                      auch eine Familie, die Hilfe brauchte.
                    </p>
                    <p>
                      «Das ist nicht in Worte zu fassen, wie sie uns damals und
                      auch später geholfen hat. Ich werde immer zu Melanie
                      Molitor aufschauen. Ich verdanke ihr wirklich einen
                      grossen Teil meiner Karriere.»
                    </p>
                    <p>
                      Und als sie sich vierzehn Jahre später in einem
                      sportlichen Tief befand, wandte sie sich an Molitors
                      Tochter und heuerte sie als Trainerin an.
                    </p>
                    <p>
                      «Mich hat immer fasziniert, wie Martina die Gegnerinnen
                      taktisch auseinandergenommen hat», erklärt sie uns. «Sie
                      hat den Platz richtig gross gemacht, hat Winkel gespielt,
                      Stoppbälle, Lob. Sie hat das Spiel wirklich voll
                      ausgespielt. Und sie hatte immer Spass am Tennis. Das
                      wollte ich auch wieder haben.»
                    </p>
                    <p>
                      Kurz nach Beginn der Zusammenarbeit merkte Lisicki
                      allerdings, dass Hingis noch immer mehr Spielerin als
                      Trainerin war. Darum fragte sie Hingis: «Kannst du dir
                      vorstellen, mit mir Doppel zu spielen?»
                    </p>
                    <p>
                      «Warum eigentlich nicht?», antwortete Hingis. «Wir müssten
                      es halt bloss ein paar Mal trainieren.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-3' id='section-7-3'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 18</h6>
                    <h5>
                      Ein lächerlicher Dopingfall und die skandalösen Folgen
                    </h5>
                    <p>
                      Wenn man als Schweizer Spitzensportler:in wissen möchte,
                      wie beliebt man im breiten Publikum ist, gibt es einen
                      sicheren Indikator: die Sports Awards.
                    </p>
                    <p>
                      Seit 1950 werden in der Vorweihnachtszeit die
                      Sportlerinnen und Sportler des Jahres gekürt. Es sind
                      nicht immer die besten, die ausgezeichnet werden, nicht
                      immer die erfolgreichsten. Es sind die populärsten. Oft
                      jene, die am volkstümlichsten wirken. Denn nicht eine
                      Fachjury trifft die Wahl, sondern ein über die Jahre stets
                      grösser gewordener Kreis von Menschen. Zunächst durften
                      Sportjournalist:innen abstimmen, ab 1999 ausserdem das
                      Fernsehpublikum. Seit 2006 gehört zudem ein Drittel der
                      Stimmen Schweizer Sportler:innen.
                    </p>
                    <p>
                      Die Sports Awards sind ein Sympathiewettbewerb mit vielen
                      hunderttausend Fernsehzuschauer:innen. Es ist einer der
                      letzten kollektiven TV-Momente der Schweiz.
                    </p>
                    <p>
                      An den Platzierungen kann man ablesen, welche Sportarten
                      in der Schweiz angesehen sind: Sie finden entweder auf
                      Schnee statt (Skifahren und Langlauf), oder es sind
                      solche, denen man die Anstrengung deutlich ansieht
                      (Leichtathletik, Triathlon, Radfahren). Die Sportlerinnen,
                      die am häufigsten ausgezeichnet wurden, sind die
                      Skifahrerin Vreni Schneider (fünfmal) sowie die Turnerin
                      Ariella Kaeslin, die Orientierungsläuferin Simone
                      Niggli-Luder und die Skifahrerin Lise-Marie Morerod (je
                      dreimal).
                    </p>
                    <p>
                      Und jetzt raten Sie, wie oft die Wahl auf Martina Hingis
                      fiel.
                    </p>
                    <p>Ein einziges Mal.</p>
                    <p>
                      Das war im unglaublichen Jahr 1997, als sie von 80 Spielen
                      75 gewann und als jüngste Tennisspielerin der Geschichte
                      die Nummer 1 wurde. Zudem wählte man sie zur
                      Weltsportlerin des Jahres – als erste Schweizerin
                      überhaupt.
                    </p>
                    <p>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-2-wimbledon_1997.jpg'
                          : '../../images/7-2-wimbledon_1997.jpg')}
                      />
                      <figcaption>
                        Die Königin von Wimbledon: Nach dem Finalsieg gegen Jana
                        Novotná 1997. Foto: Elise Amendola (Keystone/AP Photo)
                      </figcaption>
                    </p>
                    <p>
                      Und doch brachte es die Schweiz beinahe fertig, ihr die
                      nationale Ehre zu verweigern: Hingis erhielt den Titel nur
                      knapp vor der Bernerin Anita Weyermann, der «Gring abe und
                      seckle»-Athletin, die in dem Jahr WM-Bronze im
                      1500-Meter-Lauf gewonnen hatte.
                    </p>
                    <p>
                      Ein Jahr später, 1998, ging die Auszeichnung an die
                      Triathletin Natascha Badmann. Hingis schaffte es gerade
                      noch auf Platz 4, abgeschlagen hinter Marathonläuferin
                      Franziska Rochat-Moser und der zweitplatzierten Weyermann.
                      Weil sie eine schlechte Saison gespielt hatte? Natürlich
                      nicht. Sie gewann das Australian Open im Einzel und den
                      Grand-Slam im Doppel.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-3-australien_1997.jpg'
                          : '../../images/7-3-australien_1997-desktop.jpg')}
                      />
                      <figcaption>
                        Ihr Lieblingsturnier: Das Australian Open gewinnt
                        Martina Hingis drei Mal. Foto: Elise Amendola
                        (Keystone/AP Photo)
                      </figcaption>
                    </SideElement>
                    <p>
                      Und 1999, als bei den Sports Awards erstmals das
                      Fernsehpublikum mitbestimmte?
                    </p>
                    <p>
                      1999 flog Hingis in Wimbledon in der ersten Runde raus,
                      und sie scheiterte im Paris-Final unrühmlich an Steffi
                      Graf. Einige Male entlud sich ihr Frust über ihre
                      Schwierigkeiten mit dem Power-Grundlinien-Tennis in
                      abschätzigen Äusserungen gegenüber Gegnerinnen. Trotzdem
                      war es kein schlechtes Jahr: Sie gewann zum dritten Mal
                      nacheinander das Australian Open, und sie holte sich die
                      Weltranglistenführung zurück. Sie war, um es in aller
                      Klarheit zu sagen, die Weltbeste in einer Weltsportart.
                      Keine Schweizerin in keiner anderen Sportart war auch nur
                      entfernt mit ihr vergleichbar.
                    </p>
                    <p>
                      Bei den Sports Awards, die aus dem Berner Kursaal
                      übertragen wurden, waren neben ihr die Schwimmerin Flavia
                      Rigamonti und wieder die Läuferin Anita Weyermann
                      nominiert. Hingis blieb dem Anlass fern, in Florida
                      bereitete sie sich auf die neue Saison vor. Das Fernsehen
                      wollte sie live zuschalten, alles war bereit. Doch Mario
                      Widmer, der Partner von Melanie Molitor und Manager von
                      Hingis, liess ausrichten, dass sie für ein Interview nur
                      im Falle eines Sieges zur Verfügung stehe.
                    </p>
                    <p>
                      Der Moderator verkündete das vor laufender Kamera. Die
                      Antwort des Fernsehpublikums: Es wählte Weyermann, deren
                      grösster Erfolg in jenem Jahr der Europameistertitel im
                      Crosslauf gewesen war.
                    </p>
                    <p>
                      Urs Leutert, der Sportchef des Schweizer Fernsehens, sagte
                      später: «Das Verhalten von Martina ist an Zynismus nicht
                      zu überbieten. Sie hat live demonstriert, wie sehr sie das
                      Schweizer Sportpublikum und ihre Schweizer Fans
                      verachtet.»
                    </p>
                    <p>
                      Auch andere Journalist:innen waren offenbar persönlich
                      beleidigt, der «Blick» holte in Strassenumfragen zornige
                      Volksmeinungen ein. Die Stimmung gegenüber Hingis kippte
                      endgültig, sie sei, hiess es, eine schlechte Verliererin.
                    </p>
                    <SideElement side='right'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-4-autogramme_1996.jpg'
                          : '../../images/7-4-autogramme_1996-desktop.jpg')}
                      />
                      <figcaption>
                        Die erste weltweit bekannte Schweizerin: Hingis 1997 in
                        London. Foto: Elise Amendola (Keystone/AP Photo)
                      </figcaption>
                    </SideElement>
                    <p>
                      Das war sie vielleicht sogar. Aber alle
                      Spitzensportler:innen sind schlechte Verlierer:innen.
                      Sonst wären sie nicht so gut.
                    </p>
                    <p>
                      «Wo Federer Kritik mit Grösse und Gelassenheit an sich
                      abprallen lässt, da igelte sich Hingis ein und war
                      beleidigt.» Das schrieb die NZZ sogar noch zu ihrem
                      Abschied vom Sport fast zwei Jahrzehnte später.
                      Tatsächlich reagierte Federer grosszügig, als er mal eine
                      Sympathiewahl verlor (gegen den Berner Töfffahrer Tom
                      Lüthi). Doch es ist leicht, grosszügig zu sein, wenn man
                      nie angefeindet wird.
                    </p>
                    <p>
                      Martina Hingis hingegen hatte 1999 einen Spiessrutenlauf
                      hinter sich. Genaugenommen war sie – wie viele
                      Migrant:innen – schon ihr Leben lang einer oft subtilen
                      Skepsis ausgesetzt. Wer von aussen kommt, muss sich mehr
                      als andere rechtfertigen. Für Fehler, aber auch für
                      Erfolge. Man wird kritisch beäugt, wenn es schlecht läuft{' '}
                      <i>und</i> wenn es gut läuft.
                    </p>
                    <p>
                      Für Menschen, die diese Erfahrung nie machen mussten, ist
                      es schwer nachzuvollziehen, wenn Migrant:innen auf eine
                      Absage oder Nichtbeachtung heftig reagieren. Dieses oft
                      als «Dünnhäutigkeit» interpretierte Verhalten zeigt
                      letztlich, wie eine dauerhafte Erfahrung der
                      Benachteiligung oder Nichtanerkennung Spuren hinterlässt.
                      Manche macht es vorsichtig und argwöhnisch, andere wütend.
                      Beides ist ein Ausdruck von Enttäuschung.
                    </p>
                    <p>
                      Man könnte natürlich sagen: All das hätte Martina Hingis
                      egal sein können. Sie hatte Millionen, war auf der ganzen
                      Welt ein Star. Der Punkt ist: Es war ihr nicht egal. Es
                      störte sie. Sie wünschte sich Anerkennung in der Schweiz.
                      Weil sie das Land liebt. Es ist ihr Daheim.
                    </p>
                    <CareerStats />
                    <p>
                      Und dann wiederholte sich die Geschichte, und auch der
                      Schmerz wiederholte sich.
                    </p>
                    <p>
                      Weil in der Corona-Pandemie so viele Sportanlässe abgesagt
                      wurden, organisierte das Schweizer Fernsehen im Jahr 2020
                      keine normalen Sports Awards, sondern kürte die besten
                      Sportlerinnen und Sportler seit der ersten Austragung
                      1950.
                    </p>
                    <p>
                      Und Martina Hingis, die erfolgreichste Sportlerin, die die
                      Schweiz je hatte, war nicht einmal nominiert!
                    </p>
                    <p>
                      Das hängt mit einem Ereignis dreizehn Jahre zuvor
                      zusammen. Im Sommer 2007 – in der zweiten Saison seit
                      ihrem Comeback – trat Hingis noch einmal in Wimbledon an.
                      Sie wusste zu dem Zeitpunkt bereits, dass ihre grosse Zeit
                      als Einzelspielerin vorbei war. Sie hatte Rücken- und
                      Hüftprobleme, für spektakuläre Duelle mit den Weltbesten
                      reichte es immer seltener. Auch in Wimbledon rechnete sie
                      sich kaum Chancen aus, tatsächlich verlor sie in der
                      dritten Runde gegen eine unbekannte Amerikanerin.
                    </p>
                    <p>Nach der Niederlage musste sie zur Dopingkontrolle.</p>
                    <p>
                      Zehn Wochen später teilte man ihr mit, dass in ihrem Urin
                      Spuren von Benzoylecgonin gefunden worden seien.
                      Benzoylecgonin? Das ist ein Abbauprodukt von Kokain.
                    </p>
                    <p>«Sie haben Party gemacht, oder?», fragen wir Hingis.</p>
                    <p>
                      «Dann hätte ich das gesagt!», antwortet sie. «Ich war
                      immer offen. Wenn es so gewesen wäre, hätte ich gesagt:
                      ‹Ich hatte einen geilen Abend, ich habs mal probiert.
                      Super.› Aber sowas macht man nicht am Abend vor einem
                      Wimbledon-Spiel.»
                    </p>
                    <p>«Vielleicht wollten Sie Ihre Leistung steigern?»</p>
                    <SideElement side='left'>
                      <VideoPlayer
                        mp4={require('../../videos/10-dopingverdacht.mp4')}
                        posterImage={require('../../videos/10-dopingverdacht.jpg')}
                        caption='Hingis bestreitet an einer Medienkonferenz den Vorwurf, Kokain konsumiert zu haben. Material: <a href="https://www.srf.ch/play/tv/-/video/-?urn=urn:srf:video:68390643-3931-43bc-a9fc-4e62a449962f">SRF «10 vor 10»</a>'
                      />
                    </SideElement>
                    <p>
                      «Ich weiss nicht, ob ihr schon mal gekokst habt oder auf
                      einem Tennisplatz gestanden seid oder beides. Ich kann
                      euch sagen, das Letzte, was man dort braucht, sind
                      Partydrogen.»
                    </p>
                    <p>
                      Was damals in Wimbledon wirklich geschah, war Gegenstand
                      unzähliger Spekulationen. Aber eigentlich kann man es auf
                      fünf Punkte reduzieren, über die es keinen Zweifel gibt:
                    </p>
                    <ol>
                      <li>
                        So gering die Spuren auch gewesen sein mögen: Die
                        Dopingprobe war positiv.
                      </li>
                      <li>
                        Eine Haaranalyse zeigte, dass Hingis nicht regelmässig
                        Kokain konsumierte. Das aber war natürlich kein Beweis,
                        dass sie nicht vielleicht doch am Abend vor dem Spiel
                        etwas genommen hatte.
                      </li>
                      <li>
                        Hingis bestritt den Kokainkonsum und focht das Urteil
                        juristisch an. (Uns sagt sie: «Ich habe Angst vor
                        Drogen. Ich habe auch nie geraucht. Zigaretten finde ich
                        schrecklich. Ich paffe vielleicht mal eine Zigarre.»)
                      </li>
                      <li>Sie wurde zwei Jahre gesperrt.</li>
                      <li>
                        Im Jahr 2019 entschied die Welt-Anti-Doping-Agentur
                        (Wada), Freizeitdrogen wie Heroin, Cannabis, Ecstasy und
                        Kokain nicht mehr grundsätzlich als leistungssteigernd
                        einzustufen. Ein positiver Dopingtest wird nur noch mit
                        einer Dreimonatesperre bestraft.
                      </li>
                    </ol>
                    <p>
                      Den Sports Awards war das egal. Sie hatten sich den
                      Ethikzusatz auferlegt, wegen Dopings verurteilte
                      Sportlerinnen und Sportler nicht zur Wahl zuzulassen, und
                      darauf bestanden sie. Sie behandelten den überführten
                      Radfahrer, der systematisch EPO-Doping betrieben hatte,
                      genau gleich wie die Tennisspielerin, die einmalig positiv
                      auf eine Freizeitdroge getestet worden war.
                    </p>
                    <p>
                      Wie grotesk ungerecht das ist, wird noch deutlicher, wenn
                      man bedenkt, dass Hingis nach dem Absitzen der
                      Dopingsperre überall wieder mit offenen Armen empfangen
                      wurde: Auf der Tennistour sowieso, wo sie noch viele Jahre
                      erfolgreich Doppel spielte, aber auch bei Swiss Olympic,
                      dem Dachverband des Schweizer Spitzensports, der kein
                      Problem darin sah, sie für die Olympischen Spiele 2016
                      aufzubieten.
                    </p>
                    <p>
                      In all diesen Jahren wurde Hingis auch mehrmals für die
                      Sports Awards nominiert. Erst als es um die Würdigung
                      ihres Lebenswerks ging, wurde sie ausgebootet. Simon Graf,
                      Tamedia-Tennisexperte,{' '}
                      <Link allowWordWrap href='701847753466'>
                        hat dazu alles gesagt, was gesagt werden muss
                      </Link>
                      . In einem Artikel schrieb er: «Es ist, um eine Analogie
                      zum Sport zu nehmen, als ob in der Halbzeit einer Partie
                      die Spielregeln geändert würden.» Und weiter: «Wenn sie
                      mit ihrer positiven Dopingprobe ein schlechtes Vorbild
                      war, so war sie daneben auch in vielerlei Hinsicht ein
                      gutes: mit ihrer nie erlöschenden Freude für den Sport,
                      ihrem Spielwitz, ihrer erfrischenden Art in einem
                      Profizirkus, wo viele gleichgeschaltet sind. Sie hat,
                      indem sie ihren eigenen Weg ging, viele Schweizer
                      Athletinnen inspiriert. Wer ihre Karriere nun auf ihren
                      Dopingfall reduziert, tut ihr grosses Unrecht.»
                    </p>
                  </div>
                </div>
              </Element>

              <Element className='section' name='section-7-4' id='section-7-4'>
                <div className='ui text container'>
                  <div className='ta text'>
                    <h6>Kapitel 19</h6>
                    <h5>Was am Ende einer Karriere bleibt</h5>
                    <p>
                      Als Martina Hingis am 26. Oktober 2017 ihren endgültigen
                      Rücktritt verkündete, tat sie das standesgemäss: Als
                      Nummer 1 der Doppelweltrangliste. (Sie hatte einen so
                      grossen Vorsprung, dass sie noch fast ein halbes Jahr an
                      der Spitze geführt wurde, obwohl sie schon nicht mehr
                      spielte.)
                    </p>
                    <SideElement side='right'>
                      <VideoPlayer
                        mp4={require('../../videos/11-doppeltriumph_2017.mp4')}
                        posterImage={require('../../videos/11-doppeltriumph_2017.jpg')}
                        caption='Einundzwanzig Jahre nach dem ersten Grand-Slam-Gewinn: Triumph am US Open 2017 mit Latisha Chan. Material: US Open'
                      />
                    </SideElement>
                    <p>
                      Ihr letztes Jahr auf der Tour sagt mehr über sie aus, als
                      man zuerst denken würde. Besonders wenn man es durch die
                      Augen von Latisha Chan, ihrer Doppelpartnerin,
                      betrachtet. 
                    </p>
                    <p>
                      Latisha Chan, geboren 1989, wuchs in einem Dorf in Taiwan
                      auf. Sie war zehn, als ihre Familie bei einem Erdbeben
                      alles verlor, was sie besass. Die Eltern standen vor dem
                      Nichts. Wovon sollten sie jetzt leben?
                    </p>
                    <p>
                      Latisha, ein Tennistalent, bekam drei Jahre Zeit, sich zu
                      beweisen. Alles, was die Eltern verdienten, investierten
                      sie in ihr Kind. Chan zahlte das Vertrauen zurück, wurde
                      eine der weltbesten Doppelspielerinnen. Und doch erlebte
                      sie die Erwartung als Belastung.
                    </p>
                    <SideElement side='left'>
                      <img
                        className='ui image fluid'
                        src={require(isMobile
                          ? '../../images/7-5-newyork_2007.jpg'
                          : '../../images/7-5-newyork_2007.jpg')}
                      />
                      <figcaption>
                        «Sie lachte, wenn sie einen guten Ball spielte, und
                        lachte, wenn sie einen Fehler machte»: Latisha Chan über
                        ihre Doppelpartnerin. Foto: Imago/Xinhua
                      </figcaption>
                    </SideElement>
                    <p>
                      «Mit dieser Geschichte hinter mir, mit dem Wissen um das
                      Erdbeben und was es mit meiner Familie gemacht hatte,
                      glaubte ich, immer gewinnen zu müssen», sagt sie uns am
                      Telefon. Dass es auch anders geht, lernte sie erst, als
                      sie mit achtundzwanzig ein Jahr lang an der Seite ihres
                      Kindheitsidols Martina Hingis Tennis spielte.
                    </p>
                    <p>
                      «Ich war Anfang 2017 schon so viele Jahre auf der Tour,
                      dass mich alles immer nur stresste. Der Druck, das Reisen,
                      der Jetlag. Martina zeigte mir, dass man dann den lustigen
                      Teil umso mehr geniessen muss: das Spiel. Und genau so war
                      es, wenn ich neben ihr auf dem Platz stand: Ich spürte
                      ihre Energie, ich spürte sie wirklich. Ob sie gewann oder
                      verlor, war da gar nicht so wichtig. Sie lachte, wenn sie
                      einen guten Ball spielte, und lachte, wenn sie einen
                      Fehler machte. Sie wollte einfach eine gute Zeit mit ihrer
                      Partnerin haben.»
                    </p>
                    <p>Latisha Chan überlegt kurz.</p>
                    <p>
                      «Wenn ich mit ihr spielte, lachte auch ich mehr. Ja, ich
                      glaube, das ist es: Martina brachte mich zum Lachen. Ich
                      war eine andere Spielerin neben ihr. Ich traute mir
                      Schläge zu, die ich sonst nie im Leben versucht hätte. Und
                      das Beste: Ich hatte sie drauf. Ich merkte, ich bin gut
                      darin. Martina hat etwas in mir gesehen, das ich selbst
                      nicht gesehen hatte.»
                    </p>
                    <p>
                      Latisha Chan steht für zahllose Tennisspielerinnen überall
                      auf der Welt, die von Hingis inspiriert wurden. Als sie
                      als Kind einmal ein Autogramm von ihr erhielt, konnte sie
                      ihr Glück kaum fassen. Sie sagt: «Später wünschte ich mir
                      manchmal eine Zeitmaschine, um meinem achtjährigen Ich zu
                      erzählen, dass ich gerade an der Seite dieser Spielerin
                      auf den Platz laufe.»
                    </p>
                    <p>
                      Vielleicht ist es das, was am Ende einer langen
                      Sportkarriere bleibt: Dass man andere Menschen berührt
                      hat, auch ein kleines Mädchen aus einem fernen Land.
                    </p>
                  </div>
                </div>
              </Element>
            </div>
          </div>
          <Element className='section' name='section-8' id='section-8'>
            <div className='ui vertical segment'>
              <div className='ui text container'>
                <div className='ta text prologue'>
                  <h5>Epilog</h5>
                  <p>
                    Immer im Juli werden in Newport, einer Kleinstadt im
                    US-Bundesstaat Rhode Island, Spieler:innen in die Hall of
                    Fame des Tennis aufgenommen. Es ist ein bescheidener Anlass.
                    Vor wenigen Gästen wird auf dem Rasenplatz des Vereins ein
                    Podium aufgebaut, es gibt Laudationen und Beifall, die
                    Geehrten erhalten ein dunkelblaues Jackett. Das wars.
                  </p>
                  <p>
                    Tatsächlich aber ist es die ultimative Auszeichnung, die man
                    als Tennisprofi erhalten kann. Wie wichtig den Tennisstars
                    die Hall of Fame ist, versteht man erst, wenn man sich die
                    Dankesreden der letzten Jahre anhört. Es sind oft
                    erstaunlich intime Einblicke in die Seelenleben der grössten
                    Spieler:innen der letzten fünfzig Jahre.
                  </p>
                  <p>
                    An der Feier im Jahr 2009 zählte Monica Seles die Menschen
                    auf, die zu ihr hielten, als sie ganz oben war <i>und</i>{' '}
                    ganz unten. 2004 brachte Steffi Graf lange keinen Satz
                    heraus, dann sagte sie mit tränenerstickter Stimme: «Tennis
                    hat es mir ermöglicht, diese unglaubliche Reise anzutreten,
                    und das Beste an dieser Reise … sie hat mich zu dir
                    geführt.» In diesem Moment drehte sie sich um und zeigte auf
                    ihren Ehemann Andre Agassi.
                  </p>
                  <p>
                    Am 13. Juli 2013 wurde Martina Hingis in die Hall of Fame
                    aufgenommen. Phil de Picciotto, Gründer des Sportvermarkters
                    Octagon und einer der ersten Förderer von Hingis, hielt eine
                    Laudatio, die verriet, wie sehr er Hingis schätzte, als
                    Spielerin und als Mensch. Hingis kämpfte bereits mit den
                    Tränen.
                  </p>
                  <p>
                    Dann war sie dran. Sie stand auf und bedankte sich bei De
                    Picciotto. Er gab ihr zwei Küsschen auf die Wange. Hingis,
                    ganz Schweizerin, erwartete ein drittes, aber erinnerte sich
                    im letzten Moment an die internationalen Gepflogenheiten und
                    zog den Kopf zurück. Dann stellte sie sich ans Mikrofon. Sie
                    atmete einmal schwer durch. Und begann mit stockender Stimme
                    vom Blatt zu lesen.
                  </p>
                  <p>
                    «Ich könnte die Worte wiederholen, die schon so viele an
                    dieser Stelle gesagt haben, dass unser Sport mir alles im
                    Leben gegeben hat, und es wäre die Wahrheit. Aber vielleicht
                    kann ich etwas ergänzen, damit Sie besser verstehen, wer ich
                    bin und was das hier für mich bedeutet. Ich wurde geboren
                    hinter dem Eisernen Vorhang, und meine Mutter wollte den
                    Vorhang für mich niederreissen. Das ist der Grund, warum ich
                    als kleines Kind Tennis gespielt habe. 1980 hatte meine
                    Mutter nicht viele Gelegenheiten, um mir ein besseres Leben
                    zu ermöglichen und die Welt zu zeigen. Sie wählte Tennis als
                    Ausweg aus dem Gefängnis, in dem wir lebten. Danke, Mutter.»
                  </p>
                  <p>
                    Dann hob sie den Blick und richtete sich direkt an Melanie
                    Molitor: «Du hast mir mein Leben geschenkt, du hast mir
                    Liebe geschenkt, du hast mir Tennis geschenkt. Du hast mir
                    alles gegeben, was du geben konntest.»
                  </p>
                  <div style={{ marginTop: '2em' }}>
                    <VideoPlayer
                      mp4={require('../../videos/12-halloffame_2013.mp4')}
                      posterImage={require('../../videos/12-halloffame_2013.jpg')}
                      caption='Danke, Mutter: Dankesrede bei der Aufnahme in die Hall of Fame. Material: International Tennis Hall of Fame'
                    />
                  </div>
                </div>
              </div>
            </div>
          </Element>
        </div>

        <Footer
          mailTo='christof.gertsch@dasmagazin.ch,mikael.krogerus@dasmagazin.ch'
          articleId={ARTICLE_ID}
          questions={[
            'Wie informativ war der Beitrag?',
            'Wie gefällt Ihnen die Gestaltung?'
          ]}
          credits={[
            [
              'Text',
              '<a href="mailto:christof.gertsch@dasmagazin.ch">Christof Gertsch</a> & <a href="mailto:mikael.krogerus@dasmagazin.ch">Mikael Krogerus</a>, Das Magazin'
            ],
            ['Redaktion', 'Bruno Ziauddin, Das Magazin'],
            ['Porträtbilder', 'Cyrill Matter'],
            ['Haare & Make-up', 'Helve Leal'],
            ['Styling', 'Martina Russi'],
            ['Outfit', 'Strickkleid aus Merinowolle von Joseph, bei Jelmoli'],
            ['Bildredaktion', 'Carmen Brunner, Das Magazin'],
            ['Videos', 'Adrian Panholzer, Tamedia Video'],
            ['Abschlussredaktion', 'Julia Hofstetter, Das Magazin'],
            ['Digitale Umsetzung', 'Mathias Lutz, Interaktiv-Team']
          ]}
          mediaName='dasmagazin'
          fullMediaName='Das Magazin'
          hidePortfolioTeaser
        />

        <TopMenu
          ref={this.menuRef}
          menuOpen={this.state.menuOpen}
          closeMenu={this.closeMenu}
          openMenu={this.openMenu}
          menuData={parseJsonData(menuData)}
        />
      </div>
    )
  }
}
